var items = {
  "block.minecraft.air": "ءﺍﻮﻫ",
  "block.minecraft.stone": "ﺮﺠﺣ",
  "block.minecraft.granite": "ﺖﻴﻧﺍﺮﺟ",
  "block.minecraft.polished_granite": "ﻝﻮﻘﺼﻣ ﺖﻴﻧﺍﺮﺟ",
  "block.minecraft.diorite": "ﺖﻳﺭﻮﻳﺩ",
  "block.minecraft.polished_diorite": "ﻝﻮﻘﺼﻣ ﺖﻳﺭﻮﻳﺩ",
  "block.minecraft.andesite": "ﺖﻳﺎﺴﻳﺪﻧﺃ",
  "block.minecraft.polished_andesite": "ﻝﻮﻘﺼﻣ ﺖﻳﺎﺴﻳﺪﻧﺃ",
  "block.minecraft.grass_block": "ﺐﺸﻋ ﺔﻠﺘﻛ",
  "block.minecraft.dirt": "ﺏﺍﺮﺗ",
  "block.minecraft.coarse_dirt": "ﻦﺸﺧ ﺏﺍﺮﺗ",
  "block.minecraft.podzol": "ﻝﻭﺯﺩﻮﺑ",
  "block.minecraft.crimson_nylium": "ﻱﺰﻣﺮﻘﻟﺍ ﻢﻴﺤﺠﻟﺍ ﺮﻄﻓ",
  "block.minecraft.warped_nylium": "ﺐﻴﺠﻌﻟﺍ ﻢﻴﺤﺠﻟﺍ ﺮﻄﻓ",
  "block.minecraft.cobblestone": "ﻒﺻﺮﻟﺍ ﺓﺎﺼﺣ",
  "block.minecraft.oak_planks": "ﻁﻮﻠﺒﻟﺍ ﺐﺸﺧ ﺡﺍﻮﻟﺃ",
  "block.minecraft.spruce_planks": "ﺏﻮﻨﺘﻟﺍ ﺐﺸﺧ ﺡﺍﻮﻟﺃ",
  "block.minecraft.birch_planks": "ﻻﻮﺘﺒﻟﺍ ﺐﺸﺧ ﺡﺍﻮﻟﺃ",
  "block.minecraft.jungle_planks": "ﻝﺎﻏﺩﻷﺍ ﺐﺸﺧ ﺡﺍﻮﻟﺃ",
  "block.minecraft.acacia_planks": "ﻂﻨﺴﻟﺍ ﺐﺸﺧ ﺡﺍﻮﻟﺃ",
  "block.minecraft.dark_oak_planks": "ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﺐﺸﺧ ﺡﺍﻮﻟﺃ",
  "block.minecraft.crimson_planks": "ﺔﻳﺰﻣﺮﻗ ﺐﺸﺧ ﺡﺍﻮﻟﺃ",
  "block.minecraft.warped_planks": "ﺔﺒﻴﺠﻋ ﺐﺸﺧ ﺡﺍﻮﻟﺃ",
  "block.minecraft.oak_sapling": "ﻁﻮﻠﺒﻟﺍ ﺔﻠﺘﺷ",
  "block.minecraft.spruce_sapling": "ﺏﻮﻨﺘﻟﺍ ﺔﻠﺘﺷ",
  "block.minecraft.birch_sapling": "ﻻﻮﺘﺒﻟﺍ ﺔﻠﺘﺷ",
  "block.minecraft.jungle_sapling": "ﻝﺎﻏﺩﻷﺍ ﺔﻠﺘﺷ",
  "block.minecraft.acacia_sapling": "ﻂﻨﺴﻟﺍ ﺔﻠﺘﺷ",
  "block.minecraft.dark_oak_sapling": "ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﺔﻠﺘﺷ",
  "block.minecraft.bedrock": "ﻉﺎﻘﻟﺍ ﺮﺨﺻ",
  "block.minecraft.sand": "ﻞﻣﺭ",
  "block.minecraft.red_sand": "ﺮﻤﺣﺃ ﻞﻣﺭ",
  "block.minecraft.gravel": "ﻰﺼﺣ",
  "block.minecraft.gold_ore": "ﺐﻫﺬﻟﺍ ﻡﺎﺧ",
  "block.minecraft.iron_ore": "ﺪﻳﺪﺤﻟﺍ ﻡﺎﺧ",
  "block.minecraft.coal_ore": "ﻢﺤﻔﻟﺍ ﻡﺎﺧ",
  "block.minecraft.nether_gold_ore": "ﺭﺬﻨﻟﺍ ﺐﻫﺫ ﻡﺎﺧ",
  "block.minecraft.oak_log": "ﻁﻮﻠﺒﻟﺍ ﻉﺬﺟ",
  "block.minecraft.spruce_log": "ﺏﻮﻨﺘﻟﺍ ﻉﺬﺟ",
  "block.minecraft.birch_log": "ﻻﻮﺘﺒﻟﺍ ﻉﺬﺟ",
  "block.minecraft.jungle_log": "ﻝﺎﻏﺩﻷﺍ ﻉﺬﺟ",
  "block.minecraft.acacia_log": "ﻂﻨﺴﻟﺍ ﻉﺬﺟ",
  "block.minecraft.dark_oak_log": "ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﻉﺬﺟ",
  "block.minecraft.crimson_stem": "ﻱﺰﻣﺮﻗ ﻉﺬﺟ",
  "block.minecraft.warped_stem": "ﺐﻴﺠﻋ ﻉﺬﺟ",
  "block.minecraft.stripped_oak_log": "ءﺎﺤﻠﻟﺍ ﻉﻭﺰﻨﻣ ﻁﻮﻠﺒﻟﺍ ﻉﺬﺟ",
  "block.minecraft.stripped_spruce_log": "ءﺎﺤﻠﻟﺍ ﻉﻭﺰﻨﻣ ﺏﻮﻨﺘﻟﺍ ﻉﺬﺟ",
  "block.minecraft.stripped_birch_log": "ءﺎﺤﻠﻟﺍ ﻉﻭﺰﻨﻣ ﻻﻮﺘﺒﻟﺍ ﻉﺬﺟ",
  "block.minecraft.stripped_jungle_log": "ءﺎﺤﻠﻟﺍ ﻉﻭﺰﻨﻣ ﻝﺎﻏﺩﻷﺍ ﻉﺬﺟ",
  "block.minecraft.stripped_acacia_log": "ءﺎﺤﻠﻟﺍ ﻉﻭﺰﻨﻣ ﻂﻨﺴﻟﺍ ﻉﺬﺟ",
  "block.minecraft.stripped_dark_oak_log": "ءﺎﺤﻠﻟﺍ ﻉﻭﺰﻨﻣ ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﻉﺬﺟ",
  "block.minecraft.stripped_crimson_stem": "ءﺎﺤﻠﻟﺍ ﻉﻭﺰﻨﻣ ﻱﺰﻣﺮﻗ ﻉﺬﺟ",
  "block.minecraft.stripped_warped_stem": "ءﺎﺤﻠﻟﺍ ﻉﻭﺰﻨﻣ ﺐﻴﺠﻋ ﻉﺬﺟ",
  "block.minecraft.stripped_oak_wood": "ءﺎﺤﻠﻟﺍ ﻉﻭﺰﻨﻣ ﻁﻮﻠﺒﻟﺍ ﺐﺸﺧ",
  "block.minecraft.stripped_spruce_wood": "ءﺎﺤﻠﻟﺍ ﻉﻭﺰﻨﻣ ﺏﻮﻨﺘﻟﺍ ﺐﺸﺧ",
  "block.minecraft.stripped_birch_wood": "ءﺎﺤﻠﻟﺍ ﻉﻭﺰﻨﻣ ﻻﻮﺘﺒﻟﺍ ﺐﺸﺧ",
  "block.minecraft.stripped_jungle_wood": "ءﺎﺤﻠﻟﺍ ﻉﻭﺰﻨﻣ ﻝﺎﻏﺩﻷﺍ ﺐﺸﺧ",
  "block.minecraft.stripped_acacia_wood": "ءﺎﺤﻠﻟﺍ ﻉﻭﺰﻨﻣ ﻂﻨﺴﻟﺍ ﺐﺸﺧ",
  "block.minecraft.stripped_dark_oak_wood": "ءﺎﺤﻠﻟﺍ ﻉﻭﺰﻨﻣ ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﺐﺸﺧ",
  "block.minecraft.stripped_crimson_hyphae": "ءﺎﺤﻠﻟﺍ ﺔﻋﻭﺰﻨﻣ ﺔﻳﺰﻣﺮﻗ ﻁﻮﻴﺧ",
  "block.minecraft.stripped_warped_hyphae": "ءﺎﺤﻠﻟﺍ ﺔﻋﻭﺰﻨﻣ ﺔﺒﻴﺠﻋ ﺔﻳﺮﻄﻓ ﻁﻮﻴﺧ",
  "block.minecraft.oak_wood": "ﻁﻮﻠﺒﻟﺍ ﺐﺸﺧ",
  "block.minecraft.spruce_wood": "ﺏﻮﻨﺘﻟﺍ ﺐﺸﺧ",
  "block.minecraft.birch_wood": "ﻻﻮﺘﺒﻟﺍ ﺐﺸﺧ",
  "block.minecraft.jungle_wood": "ﻝﺎﻏﺩﻷﺍ ﺐﺸﺧ",
  "block.minecraft.acacia_wood": "ﻂﻨﺴﻟﺍ ﺐﺸﺧ",
  "block.minecraft.dark_oak_wood": "ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﺐﺸﺧ",
  "block.minecraft.crimson_hyphae": "hyphae ﻱﺰﻣﺮﻗ",
  "block.minecraft.warped_hyphae": "ﺔﺒﻴﺠﻋ ﺔﻳﺮﻄﻓ ﻁﻮﻴﺧ",
  "block.minecraft.oak_leaves": "ﻁﻮﻠﺒﻟﺍ ﻕﺍﺭﻭﺃ",
  "block.minecraft.spruce_leaves": "ﺏﻮﻨﺘﻟﺍ ﻕﺍﺭﻭﺃ",
  "block.minecraft.birch_leaves": "ﻻﻮﺘﺒﻟﺍ ﻕﺍﺭﻭﺃ",
  "block.minecraft.jungle_leaves": "ﻝﺎﻏﺩﻷﺍ ﻕﺍﺭﻭﺃ",
  "block.minecraft.acacia_leaves": "ﻂﻨﺴﻟﺍ ﻕﺍﺭﻭﺃ",
  "block.minecraft.dark_oak_leaves": "ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﻕﺍﺭﻭﺃ",
  "block.minecraft.sponge": "ﺞﻨﻔﺳﺇ",
  "block.minecraft.wet_sponge": "ﺐﻃﺭ ﺞﻨﻔﺳﺇ",
  "block.minecraft.glass": "ﺝﺎﺟﺯ",
  "block.minecraft.lapis_ore": "ﺩﺭﻭﺯﻼﻟﺍ ﻡﺎﺧ",
  "block.minecraft.lapis_block": "ﺩﺭﻭﺯﻻ ﺔﻠﺘﻛ",
  "block.minecraft.dispenser": "ﻑﺫﺎﻗ",
  "block.minecraft.sandstone": "ﻲﻠﻣﺭ ﺮﺠﺣ",
  "block.minecraft.chiseled_sandstone": "ﺵﻮﻘﻨﻣ ﻲﻠﻣﺭ ﺮﺠﺣ",
  "block.minecraft.cut_sandstone": "ﻊﻄﻘﻣ ﻲﻠﻣﺭ ﺮﺠﺤﻟﺍ",
  "block.minecraft.note_block": "ﺔﺗﻮﻨﻟﺍ ﺔﻠﺘﻛ",
  "block.minecraft.powered_rail": "ﺔﻗﺎﻄﻟﺎﺑ ﻞﻤﻌﺗ ﺔﻳﺪﻳﺪﺣ ﺔﻜﺳ",
  "block.minecraft.detector_rail": "ﺓﺮﻌﺸﺘﺴﻣ ﺔﻳﺪﻳﺪﺣ ﺔﻜﺳ",
  "block.minecraft.sticky_piston": "ﺝﺰﻟ ﺲﺒﻜﻣ",
  "block.minecraft.cobweb": "ﺕﻮﺒﻜﻨﻌﻟﺍ ﺔﻜﺒﺷ",
  "block.minecraft.grass": "ﺐﺸﻋ",
  "block.minecraft.fern": "ﺲﺧﺮﺳ",
  "block.minecraft.dead_bush": "ﺔﺘﻴﻣ ﺓﺮﻴﺠﺷ",
  "block.minecraft.seagrass": "ﺮﺤﺒﻟﺍ ﺏﺎﺸﻋﺃ",
  "block.minecraft.sea_pickle": "ﺮﺤﺒﻟﺍ ﺭﺎﻴﺧ",
  "block.minecraft.piston": "ﺲﺒﻜﻣ",
  "block.minecraft.white_wool": "ﺾﻴﺑﺃ ﻑﻮﺻ",
  "block.minecraft.orange_wool": "ﻲﻟﺎﻘﺗﺮﺑ ﻑﻮﺻ",
  "block.minecraft.magenta_wool": "ﻲﻧﺍﻮﺟﺭﺃ ﻑﻮﺻ",
  "block.minecraft.light_blue_wool": "ﺢﺗﺎﻓ ﻕﺭﺯﺃ ﻑﻮﺻ",
  "block.minecraft.yellow_wool": "ﺮﻔﺻﺃ ﻑﻮﺻ",
  "block.minecraft.lime_wool": "ﻲﻧﻮﻤﻴﻟ ﻑﻮﺻ",
  "block.minecraft.pink_wool": "ﻱﺩﺭﻭ ﻑﻮﺻ",
  "block.minecraft.gray_wool": "ﻱﺩﺎﻣﺭ ﻑﻮﺻ",
  "block.minecraft.light_gray_wool": "ﺢﺗﺎﻓ ﻱﺩﺎﻣﺭ ﻑﻮﺻ",
  "block.minecraft.cyan_wool": "ﻱﻭﺎﻤﺳ ﻑﻮﺻ",
  "block.minecraft.purple_wool": "ﻲﺠﺴﻔﻨﺑ ﻑﻮﺻ",
  "block.minecraft.blue_wool": "ﻕﺭﺯﺃ ﻑﻮﺻ",
  "block.minecraft.brown_wool": "ﻲﻨﺑ ﻑﻮﺻ",
  "block.minecraft.green_wool": "ﺮﻀﺧﺃ ﻑﻮﺻ",
  "block.minecraft.red_wool": "ﺮﻤﺣﺃ ﻑﻮﺻ",
  "block.minecraft.black_wool": "ﺩﻮﺳﺃ ﻑﻮﺻ",
  "block.minecraft.dandelion": "ءﺎﺑﺪﻨﻬﻟﺍ",
  "block.minecraft.poppy": "ﺵﺎﺨﺸﺧ",
  "block.minecraft.blue_orchid": "ﻕﺭﺯﺃ ﺪﻴﻛﺭﻭﺃ",
  "block.minecraft.allium": "ﻡﻮﺜﻟﺍ ﺓﺮﻫﺯ",
  "block.minecraft.azure_bluet": "ءﺎﻗﺭﺰﻟﺍ ﺔﻳﺩﺭﻭﺯﻼﻟﺍ ﺓﺮﻫﺯ",
  "block.minecraft.red_tulip": "ﺮﻤﺣﻷﺍ ﺐﻴﻟﻮﺘﻟﺍ ﺓﺮﻫﺯ",
  "block.minecraft.orange_tulip": "ﻲﻟﺎﻘﺗﺮﺒﻟﺍ ﺐﻴﻟﻮﺘﻟﺍ ﺓﺮﻫﺯ",
  "block.minecraft.white_tulip": "ﺾﻴﺑﻷﺍ ﺐﻴﻟﻮﺘﻟﺍ ﺓﺮﻫﺯ",
  "block.minecraft.pink_tulip": "ﻱﺩﺭﻮﻟﺍ ﺐﻴﻟﻮﺘﻟﺍ ﺓﺮﻫﺯ",
  "block.minecraft.oxeye_daisy": "ﺝﻭﺮﻤﻟﺍ ﻥﺍﻮﺤﻗﺃ",
  "block.minecraft.cornflower": "ﺓﺭﺬﻟﺍ ﺓﺩﺭﻭ",
  "block.minecraft.lily_of_the_valley": "ﻱﺩﺍﻮﻟﺍ ﻖﺒﻧﺯ",
  "block.minecraft.wither_rose": "ﺭﺫﻮﻟﺍ ﺓﺮﻫﺯ",
  "block.minecraft.brown_mushroom": "ﻲﻨﺑ ﺮﻄﻓ",
  "block.minecraft.red_mushroom": "ﺮﻤﺣﺃ ﺮﻄﻓ",
  "block.minecraft.crimson_fungus": "ﻱﺰﻣﺮﻗ ﺮﻄﻓ",
  "block.minecraft.warped_fungus": "ﺐﻴﺠﻋ ﺮﻄﻓ",
  "block.minecraft.crimson_roots": "ﺔﻳﺰﻣﺮﻗ ﺭﻭﺬﺟ",
  "block.minecraft.warped_roots": "ﺔﺒﻴﺠﻋ ﺭﻭﺬﺟ",
  "block.minecraft.nether_sprouts": "ﺭﺬﻨﻟﺍ ﻢﻋﺍﺮﺑ",
  "block.minecraft.weeping_vines": "ﻲﻟﺪﺘﻣ ﻖﻠﺴﺘﻣ ﺕﺎﺒﻧ",
  "block.minecraft.twisting_vines": "ﻱﻮﺘﻠﻣ ﻖﻠﺴﺘﻣ ﺕﺎﺒﻧ",
  "block.minecraft.sugar_cane": "ﺮﻜﺴﻟﺍ ﺐﺼﻗ",
  "block.minecraft.kelp": "ﺮﺤﺒﻟﺍ ﺐﺸﻋ",
  "block.minecraft.bamboo": "ﻥﺍﺭﺰﻴﺨﻟﺍ ﺐﺼﻗ",
  "block.minecraft.gold_block": "ﺐﻫﺬﻟﺍ ﻦﻣ ﺔﻠﺘﻛ",
  "block.minecraft.iron_block": "ﺪﻳﺪﺤﻟﺍ ﻦﻣ ﺔﻠﺘﻛ",
  "block.minecraft.oak_slab": "ﻁﻮﻠﺒﻟﺍ ﺔﻃﻼﺑ",
  "block.minecraft.spruce_slab": "ﺏﻮﻨﺘﻟﺍ ﺔﻃﻼﺑ",
  "block.minecraft.birch_slab": "ﻻﻮﺘﺒﻟﺍ ﺔﻃﻼﺑ",
  "block.minecraft.jungle_slab": "ﻝﺎﻏﺩﻷﺍ ﺔﻃﻼﺑ",
  "block.minecraft.acacia_slab": "ﻂﻨﺴﻟﺍ ﺔﻃﻼﺑ",
  "block.minecraft.dark_oak_slab": "ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﺔﻃﻼﺑ",
  "block.minecraft.crimson_slab": "ﺔﻳﺰﻣﺮﻗ ﺔﻃﻼﺑ",
  "block.minecraft.warped_slab": "ﺔﺒﻴﺠﻋ ﺔﻃﻼﺑ",
  "block.minecraft.stone_slab": "ﺔﻳﺮﺠﺣ ﺔﻃﻼﺑ",
  "block.minecraft.smooth_stone_slab": "ﺲﻠﻣﺃ ﺮﺠﺣ ﺔﻃﻼﺑ",
  "block.minecraft.sandstone_slab": "ﻲﻠﻣﺭ ﺮﺠﺣ ﺔﻃﻼﺑ",
  "block.minecraft.cut_sandstone_slab": "ﺔﻌﻄﻘﻣ ﻲﻠﻣﺭ ﺮﺠﺣ ﺔﻃﻼﺑ",
  "block.minecraft.petrified_oak_slab": "ﺓﺮﺠﺤﺘﻤﻟﺍ ﻁﻮﻠﺒﻟﺍ ﺐﺸﺧ ﺔﻃﻼﺑ",
  "block.minecraft.cobblestone_slab": "ﻒﺻﺮﻟﺍ ﺓﺎﺼﺣ ﺔﻃﻼﺑ",
  "block.minecraft.brick_slab": "ﺏﻮﻃ ﺔﻃﻼﺑ",
  "block.minecraft.stone_brick_slab": "ﻱﺮﺠﺣ ﺏﻮﻃ ﺔﻃﻼﺑ",
  "block.minecraft.nether_brick_slab": "ﺭﺬﻨﻟﺍ ﺏﻮﻃ ﺔﻃﻼﺑ",
  "block.minecraft.quartz_slab": "ﺰﺗﺭﺍﻮﻛ ﺔﻃﻼﺑ",
  "block.minecraft.red_sandstone_slab": "ﺮﻤﺣﺃ ﻲﻠﻣﺭ ﺮﺠﺣ ﺔﻃﻼﺑ",
  "block.minecraft.cut_red_sandstone_slab": "ﺔﻌﻄﻘﻣ ﺮﻤﺣﺃ ﻲﻠﻣﺭ ﺮﺠﺣ ﺔﻃﻼﺑ",
  "block.minecraft.purpur_slab": "ﺮﺑﺮﺑ ﺔﻃﻼﺑ",
  "block.minecraft.prismarine_slab": "ﻦﻳﺭﺎﻤﺴﻳﺮﺑ ﺔﻃﻼﺑ",
  "block.minecraft.prismarine_brick_slab": "ﻦﻳﺭﺎﻤﺴﻳﺮﺒﻟﺍ ﺏﻮﻃ ﺔﻃﻼﺑ",
  "block.minecraft.dark_prismarine_slab": "ﻦﻛﺍﺪﻟﺍ ﻦﻳﺭﺎﻤﺴﻳﺮﺒﻟﺍ ﺔﻃﻼﺑ",
  "block.minecraft.smooth_quartz": "ﺔﻤﻋﺎﻧ ﺰﺗﺭﺍﻮﻛ ﺔﻠﺘﻛ",
  "block.minecraft.smooth_red_sandstone": "ﺲﻠﻣﺃ ﺮﻤﺣﺃ ﻲﻠﻣﺭ ﺮﺠﺣ",
  "block.minecraft.smooth_sandstone": "ﺲﻠﻣﺃ ﻲﻠﻣﺭ ﺮﺠﺣ",
  "block.minecraft.smooth_stone": "ﺲﻠﻣﺃ ﺮﺠﺣ",
  "block.minecraft.bricks": "ﺏﻮﻃ",
  "block.minecraft.tnt": "ﺖﻴﻣﺎﻨﻳﺩ",
  "block.minecraft.bookshelf": "ﺐﺘﻛ ﻑﺭ",
  "block.minecraft.mossy_cobblestone": "ﺔﺒﻠﺤﻄﻣ ﻒﺻﺭ ﺓﺎﺼﺣ",
  "block.minecraft.obsidian": "ﺞﺒﺳ",
  "block.minecraft.torch": "ﺔﻠﻌﺷ",
  "block.minecraft.end_rod": "ﺪﻧﻻﺍ ﺩﻮﻋ",
  "block.minecraft.chorus_plant": "ﺱﺭﻮﻜﻟﺍ ﺔﺘﺒﻧ",
  "block.minecraft.chorus_flower": "ﺱﺭﻮﻜﻟﺍ ﺓﺮﻫﺯ",
  "block.minecraft.purpur_block": "ﺮﺑﺮﺑ ﺔﻠﺘﻛ",
  "block.minecraft.purpur_pillar": "ﺮﺑﺮﺑ ﺩﻮﻤﻋ",
  "block.minecraft.purpur_stairs": "ﺮﺑﺮﺑ ﺝﺭﺩ",
  "block.minecraft.spawner": "ﺪﻟﻮﻣ",
  "block.minecraft.oak_stairs": "ﻁﻮﻠﺒﻟﺍ ﺝﺭﺩ",
  "block.minecraft.chest": "ﻕﻭﺪﻨﺻ",
  "block.minecraft.diamond_ore": "ﺱﺎﻤﻟﻷﺍ ﻡﺎﺧ",
  "block.minecraft.diamond_block": "ﺱﺎﻤﻟﻷﺍ ﻦﻣ ﺔﻠﺘﻛ",
  "block.minecraft.crafting_table": "ﺓﺭﺎﺠﻨﻟﺍ ﺔﻟﻭﺎﻃ",
  "block.minecraft.farmland": "ﺔﻴﻋﺍﺭﺯ ﺽﺭﺃ",
  "block.minecraft.furnace": "ﻥﺮﻓ",
  "block.minecraft.ladder": "ﻢﻠﺳ",
  "block.minecraft.rail": "ﺔﻳﺪﻳﺪﺣ ﺔﻜﺳ",
  "block.minecraft.cobblestone_stairs": "ﻒﺻﺮﻟﺍ ﺓﺎﺼﺣ ﺝﺭﺩ",
  "block.minecraft.lever": "ﺾﺒﻘﻣ",
  "block.minecraft.stone_pressure_plate": "ﺔﻳﺮﺠﺣ ﻂﻐﺿ ﺔﺤﻴﻔﺻ",
  "block.minecraft.oak_pressure_plate": "ﻁﻮﻠﺒﻟﺍ ﺐﺸﺧ ﻂﻐﺿ ﺔﺤﻴﻔﺻ",
  "block.minecraft.spruce_pressure_plate": "ﺏﻮﻨﺘﻟﺍ ﺐﺸﺧ ﻂﻐﺿ ﺔﺤﻴﻔﺻ",
  "block.minecraft.birch_pressure_plate": "ﻻﻮﺘﺒﻟﺍ ﺐﺸﺧ ﻂﻐﺿ ﺔﺤﻴﻔﺻ",
  "block.minecraft.jungle_pressure_plate": "ﻝﺎﻏﺩﻷﺍ ﺐﺸﺧ ﻂﻐﺿ ﺔﺤﻴﻔﺻ",
  "block.minecraft.acacia_pressure_plate": "ﻂﻨﺴﻟﺍ ﺐﺸﺧ ﻂﻐﺿ ﺔﺤﻴﻔﺻ",
  "block.minecraft.dark_oak_pressure_plate": "ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﺐﺸﺧ ﻂﻐﺿ ﺔﺤﻴﻔﺻ",
  "block.minecraft.crimson_pressure_plate": "ﺔﻳﺰﻣﺮﻗ ﻂﻐﺿ ﺔﺤﻴﻔﺻ",
  "block.minecraft.warped_pressure_plate": "ﺔﺒﻴﺠﻋ ﻂﻐﺿ ﺔﺣﻮﻟ",
  "block.minecraft.polished_blackstone_pressure_plate": "ﻝﻮﻘﺼﻣ ﺩﻮﺳﺃ ﺮﺠﺣ ﻂﻐﺿ ﺔﺤﻴﻔﺻ",
  "block.minecraft.redstone_ore": "ﻥﻮﺘﺳﺪﻳﺮﻟﺍ ﻡﺎﺧ",
  "block.minecraft.redstone_torch": "ﻥﻮﺘﺳﺪﻳﺮﻟﺍ ﺔﻠﻌﺷ",
  "block.minecraft.snow": "ﺞﻠﺛ",
  "block.minecraft.ice": "ﺪﻴﻠﺟ",
  "block.minecraft.snow_block": "ﺞﻠﺛ ﺔﻠﺘﻛ",
  "block.minecraft.cactus": "ﺭﺎﺒﺻ",
  "block.minecraft.clay": "ﻝﺎﺼﻠﺻ",
  "block.minecraft.jukebox": "ﻰﻘﻴﺳﻮﻤﻟﺍ ﻕﻭﺪﻨﺻ",
  "block.minecraft.oak_fence": "ﻁﻮﻠﺒﻟﺍ ﺝﺎﻴﺳ",
  "block.minecraft.spruce_fence": "ﺏﻮﻨﺘﻟﺍ ﺝﺎﻴﺳ",
  "block.minecraft.birch_fence": "ﻻﻮﺘﺒﻟﺍ ﺝﺎﻴﺳ",
  "block.minecraft.jungle_fence": "ﻝﺎﻏﺩﻷﺍ ﺝﺎﻴﺳ",
  "block.minecraft.acacia_fence": "ﻂﻨﺴﻟﺍ ﺝﺎﻴﺳ",
  "block.minecraft.dark_oak_fence": "ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﺝﺎﻴﺳ",
  "block.minecraft.crimson_fence": "ﻱﺰﻣﺮﻗ ﺝﺎﻴﺳ",
  "block.minecraft.warped_fence": "ﺐﻴﺠﻋ ﺝﺎﻴﺳ",
  "block.minecraft.pumpkin": "ﻦﻴﻄﻘﻳ",
  "block.minecraft.carved_pumpkin": "ﺕﻮﺤﻨﻣ ﻦﻴﻄﻘﻳ",
  "block.minecraft.netherrack": "ﻙﺍﺭﺭﺬﻧ",
  "block.minecraft.soul_sand": "ﺡﻭﺮﻟﺍ ﻞﻣﺭ",
  "block.minecraft.soul_soil": "ﺡﻭﺮﻟﺍ ﺔﺑﺮﺗ",
  "block.minecraft.basalt": "ﺖﻟﺯﺎﺑ",
  "block.minecraft.polished_basalt": "ﻝﻮﻘﺼﻣ ﺖﻟﺯﺎﺑ",
  "block.minecraft.soul_torch": "ﺔﻴﺣﻭﺭ ﺔﻠﻌﺷ",
  "block.minecraft.glowstone": "ءﻲﻀﻣ ﺮﺠﺣ",
  "block.minecraft.jack_o_lantern": "ءﻲﻀﻣ ﻦﻴﻄﻘﻳ",
  "block.minecraft.oak_trapdoor": "ﻁﻮﻠﺒﻟﺍ ﺐﺸﺧ ﻦﻣ ﻲﺿﺭﺃ ﺏﺎﺑ",
  "block.minecraft.spruce_trapdoor": "ﺏﻮﻨﺘﻟﺍ ﺐﺸﺧ ﻦﻣ ﻲﺿﺭﺃ ﺏﺎﺑ",
  "block.minecraft.birch_trapdoor": "ﻻﻮﺘﺒﻟﺍ ﺐﺸﺧ ﻦﻣ ﻲﺿﺭﺃ ﺏﺎﺑ",
  "block.minecraft.jungle_trapdoor": "ﻝﺎﻏﺩﻷﺍ ﺐﺸﺧ ﻦﻣ ﻲﺿﺭﺃ ﺏﺎﺑ",
  "block.minecraft.acacia_trapdoor": "ﻂﻨﺴﻟﺍ ﺐﺸﺧ ﻦﻣ ﻲﺿﺭﺃ ﺏﺎﺑ",
  "block.minecraft.dark_oak_trapdoor": "ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﺐﺸﺧ ﻦﻣ ﻲﺿﺭﺃ ﺏﺎﺑ",
  "block.minecraft.crimson_trapdoor": "ﻱﺰﻣﺮﻗ ﻲﺿﺭﺃ ﺏﺎﺑ",
  "block.minecraft.warped_trapdoor": "ﺐﻴﺠﻋ ﻲﺿﺭﺃ ﺏﺎﺑ",
  "block.minecraft.infested_stone": "ﻥﻮﻜﺴﻣ ﺮﺠﺣ",
  "block.minecraft.infested_cobblestone": "ﺔﻧﻮﻜﺴﻤﻟﺍ ﻒﺻﺮﻟﺍ ﺓﺎﺼﺣ",
  "block.minecraft.infested_stone_bricks": "ﻥﻮﻜﺴﻣ ﻱﺮﺠﺣ ﺏﻮﻃ",
  "block.minecraft.infested_mossy_stone_bricks": "ﻥﻮﻜﺴﻣ ﻲﺒﻠﺤﻃ ﻱﺮﺠﺣ ﺏﻮﻃ",
  "block.minecraft.infested_cracked_stone_bricks": "ﻥﻮﻜﺴﻣ ﻖﻘﺸﺘﻣ ﻱﺮﺠﺣ ﺏﻮﻃ",
  "block.minecraft.infested_chiseled_stone_bricks": "ﻥﻮﻜﺴﻣ ﺵﻮﻘﻨﻣ ﻱﺮﺠﺣ ﺏﻮﻃ",
  "block.minecraft.stone_bricks": "ﻱﺮﺠﺣ ﺏﻮﻃ",
  "block.minecraft.mossy_stone_bricks": "ﺐﻠﺤﻄﻣ ﻱﺮﺠﺣ ﺏﻮﻃ",
  "block.minecraft.cracked_stone_bricks": "ﻖﻘﺸﺘﻣ ﻱﺮﺠﺣ ﺏﻮﻃ",
  "block.minecraft.chiseled_stone_bricks": "ﺵﻮﻘﻨﻣ ﻱﺮﺠﺣ ﺏﻮﻃ",
  "block.minecraft.brown_mushroom_block": "ﻲﻨﺒﻟﺍ ﺮﻄﻔﻟﺍ ﺐﻌﻜﻣ",
  "block.minecraft.red_mushroom_block": "ﺮﻤﺣﺃ ﺮﻄﻓ ﺔﻠﺘﻛ",
  "block.minecraft.mushroom_stem": "ﺮﻄﻔﻟﺍ ﻉﺬﺟ",
  "block.minecraft.iron_bars": "ﺔﻳﺪﻳﺪﺣ ﻥﺎﺒﻀﻗ",
  "block.minecraft.chain": "ﺔﻠﺴﻠﺳ",
  "block.minecraft.glass_pane": "ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.melon": "ﺔﺨﻴﻄﺑ",
  "block.minecraft.vine": "ﻖﻠﺴﺘﻣ ﺕﺎﺒﻧ",
  "block.minecraft.oak_fence_gate": "ﻁﻮﻠﺒﻟﺍ ﺝﺎﻴﺳ ﺔﺑﺍﻮﺑ",
  "block.minecraft.spruce_fence_gate": "ﺏﻮﻨﺘﻟﺍ ﺝﺎﻴﺳ ﺔﺑﺍﻮﺑ",
  "block.minecraft.birch_fence_gate": "ﻻﻮﺘﺒﻟﺍ ﺝﺎﻴﺳ ﺔﺑﺍﻮﺑ",
  "block.minecraft.jungle_fence_gate": "ﻝﺎﻏﺩﻷﺍ ﺝﺎﻴﺳ ﺔﺑﺍﻮﺑ",
  "block.minecraft.acacia_fence_gate": "ﻂﻨﺴﻟﺍ ﺝﺎﻴﺳ ﺔﺑﺍﻮﺑ",
  "block.minecraft.dark_oak_fence_gate": "ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﺝﺎﻴﺳ ﺔﺑﺍﻮﺑ",
  "block.minecraft.crimson_fence_gate": "ﺔﻳﺰﻣﺮﻗ ﺝﺎﻴﺳ ﺔﺑﺍﻮﺑ",
  "block.minecraft.warped_fence_gate": "ﺔﺒﻴﺠﻋ ﺝﺎﻴﺳ ﺔﺑﺍﻮﺑ",
  "block.minecraft.brick_stairs": "ﺏﻮﻄﻟﺍ ﻦﻣ ﺝﺭﺩ",
  "block.minecraft.stone_brick_stairs": "ﻱﺮﺠﺤﻟﺍ ﺏﻮﻄﻟﺍ ﻦﻣ ﺝﺭﺩ",
  "block.minecraft.mycelium": "ﺓﺭﻮﻄﻓﺃ",
  "block.minecraft.lily_pad": "ءﺎﻤﻟﺍ ﻖﺒﻧﺯ",
  "block.minecraft.nether_bricks": "ﺭﺬﻨﻟﺍ ﺏﻮﻃ",
  "block.minecraft.cracked_nether_bricks": "ﻖﻘﺸﺘﻤﻟﺍ ﺭﺬﻨﻟﺍ ﺏﻮﻃ",
  "block.minecraft.chiseled_nether_bricks": "ﺵﻮﻘﻨﻤﻟﺍ ﺭﺬﻨﻟﺍ ﺏﻮﻃ",
  "block.minecraft.nether_brick_fence": "ﺭﺬﻨﻟﺍ ﺏﻮﻃ ﺝﺎﻴﺳ",
  "block.minecraft.nether_brick_stairs": "ﺭﺬﻨﻟﺍ ﺏﻮﻃ ﺝﺭﺩ",
  "block.minecraft.enchanting_table": "ﺮﺤﺴﻟﺍ ﺔﻟﻭﺎﻃ",
  "block.minecraft.end_portal_frame": "ﺪﻧﻻﺍ ﺔﺑﺍﻮﺑ ﺭﺎﻃﺇ",
  "block.minecraft.end_stone": "ﺪﻧﻻﺍ ﺮﺠﺣ",
  "block.minecraft.end_stone_bricks": "ﺪﻧﻻﺍ ﺮﺠﺣ ﺏﻮﻃ",
  "block.minecraft.dragon_egg": "ﻦﻴﻨﺗ ﺔﻀﻴﺑ",
  "block.minecraft.redstone_lamp": "ﻥﻮﺘﺳﺪﻳﺮﻟﺍ ﺡﺎﺒﺼﻣ",
  "block.minecraft.sandstone_stairs": "ﻲﻠﻣﺭ ﺮﺠﺣ ﺝﺭﺩ",
  "block.minecraft.emerald_ore": "ﺩﺮﻣﺰﻟﺍ ﻡﺎﺧ",
  "block.minecraft.ender_chest": "ﺭﺪﻧﻻﺍ ﻕﻭﺪﻨﺻ",
  "block.minecraft.tripwire_hook": "ﺓﺪﻴﺼﻤﻟﺍ ﻚﻠﺳ ﻑﺎﻄﺧ",
  "block.minecraft.emerald_block": "ﺩﺮﻣﺰﻟﺍ ﻦﻣ ﺔﻠﺘﻛ",
  "block.minecraft.spruce_stairs": "ﺏﻮﻨﺘﻟﺍ ﺝﺭﺩ",
  "block.minecraft.birch_stairs": "ﻻﻮﺘﺒﻟﺍ ﺝﺭﺩ",
  "block.minecraft.jungle_stairs": "ﻝﺎﻏﺩﻷﺍ ﺝﺭﺩ",
  "block.minecraft.crimson_stairs": "ﻱﺰﻣﺮﻗ ﺝﺭﺩ",
  "block.minecraft.warped_stairs": "ﺐﻴﺠﻋ ﺝﺭﺩ",
  "block.minecraft.command_block": "ﺮﻣﺍﻭﻷﺍ ﺔﻠﺘﻛ",
  "block.minecraft.beacon": "ﺓﺭﺎﻨﻣ",
  "block.minecraft.cobblestone_wall": "ﻒﺻﺮﻟﺍ ﺓﺎﺼﺣ ﺭﺍﺪﺟ",
  "block.minecraft.mossy_cobblestone_wall": "ﺐﻠﺤﻄﻣ ﻒﺻﺭ ﺓﺎﺼﺣ ﺭﺍﺪﺟ",
  "block.minecraft.brick_wall": "ﻲﺑﻮﻃ ﺭﺍﺪﺟ",
  "block.minecraft.prismarine_wall": "ﻦﻳﺭﺎﻤﺴﻳﺮﺑ ﺭﺍﺪﺟ",
  "block.minecraft.red_sandstone_wall": "ﺮﻤﺣﺃ ﻲﻠﻣﺭ ﺮﺠﺣ ﺭﺍﺪﺟ",
  "block.minecraft.mossy_stone_brick_wall": "ﺐﻠﺤﻄﻣ ﻱﺮﺠﺣ ﺏﻮﻃ ﺭﺍﺪﺟ",
  "block.minecraft.granite_wall": "ﺖﻴﻧﺍﺮﺟ ﺭﺍﺪﺟ",
  "block.minecraft.stone_brick_wall": "ﻱﺮﺠﺣ ﺏﻮﻃ ﺭﺍﺪﺟ",
  "block.minecraft.nether_brick_wall": "ﺭﺬﻨﻟﺍ ﺏﻮﻃ ﺭﺍﺪﺟ",
  "block.minecraft.andesite_wall": "ﺖﻳﺎﺴﻳﺪﻧﺃ ﺭﺍﺪﺟ",
  "block.minecraft.red_nether_brick_wall": "ﺮﻤﺣﻷﺍ ﺭﺬﻨﻟﺍ ﺏﻮﻃ ﺭﺍﺪﺟ",
  "block.minecraft.sandstone_wall": "ﻲﻠﻣﺭ ﺮﺠﺣ ﺭﺍﺪﺟ",
  "block.minecraft.end_stone_brick_wall": "ﺪﻧﻻﺍ ﺮﺠﺣ ﺏﻮﻃ ﺭﺍﺪﺟ",
  "block.minecraft.diorite_wall": "ﺖﻳﺭﻮﻳﺩ ﺭﺍﺪﺟ",
  "block.minecraft.blackstone_wall": "ﺩﻮﺳﺃ ﺮﺠﺣ ﺭﺍﺪﺟ",
  "block.minecraft.polished_blackstone_wall": "ﻝﻮﻘﺼﻣ ﺩﻮﺳﺃ ﺮﺠﺣ ﺭﺍﺪﺟ",
  "block.minecraft.polished_blackstone_brick_wall": "ﻝﻮﻘﺼﻣ ﺩﻮﺳﺃ ﺮﺠﺣ ﺭﺍﺪﺟ",
  "block.minecraft.stone_button": "ﻱﺮﺠﺣ ﺭﺯ",
  "block.minecraft.oak_button": "ﻁﻮﻠﺒﻟﺍ ﺐﺸﺧ ﺭﺯ",
  "block.minecraft.spruce_button": "ﺏﻮﻨﺘﻟﺍ ﺐﺸﺧ ﺭﺯ",
  "block.minecraft.birch_button": "ﻻﻮﺘﺒﻟﺍ ﺐﺸﺧ ﺭﺯ",
  "block.minecraft.jungle_button": "ﻝﺎﻏﺩﻷﺍ ﺐﺸﺧ ﺭﺯ",
  "block.minecraft.acacia_button": "ﻂﻨﺴﻟﺍ ﺐﺸﺧ ﺭﺯ",
  "block.minecraft.dark_oak_button": "ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﺐﺸﺧ ﺭﺯ",
  "block.minecraft.crimson_button": "ﻱﺰﻣﺮﻗ ﺭﺯ",
  "block.minecraft.warped_button": "ﺐﻴﺠﻋ ﺭﺯ",
  "block.minecraft.polished_blackstone_button": "ﻝﻮﻘﺼﻣ ﺩﻮﺳﺃ ﺮﺠﺣ ﻦﻣ ﺭﺯ",
  "block.minecraft.anvil": "ﻥﺍﺪﻨﺳ",
  "block.minecraft.chipped_anvil": "ﺮﺴﻜﺘﻣ ﻥﺍﺪﻨﺳ",
  "block.minecraft.damaged_anvil": "ﺭﺮﻀﺘﻤﻟﺍ ﻥﺍﺪﻨﺳ",
  "block.minecraft.trapped_chest": "ﺦﺨﻔﻣ ﻕﻭﺪﻨﺻ",
  "block.minecraft.light_weighted_pressure_plate": "ﻥﺯﻮﻟﺍ ﺔﻔﻴﻔﺧ ﻂﻐﺿ ﺔﺤﻴﻔﺻ",
  "block.minecraft.heavy_weighted_pressure_plate": "ﻥﺯﻮﻟﺍ ﺔﻠﻴﻘﺛ ﻂﻐﺿ ﺔﺤﻴﻔﺻ",
  "block.minecraft.daylight_detector": "ﺲﻤﺸﻟﺍ ءﻮﺿ ﺱﺎﺴﺣ",
  "block.minecraft.redstone_block": "ﻥﻮﺘﺳﺪﻳﺮﻟﺍ ﻦﻣ ﺔﻠﺘﻛ",
  "block.minecraft.nether_quartz_ore": "ﺰﺗﺭﺍﻮﻜﻟﺍ ﻡﺎﺧ",
  "block.minecraft.hopper": "ﺮﺑﻮﻫ",
  "block.minecraft.chiseled_quartz_block": "ﺕﻮﺤﻨﻣ ﺰﺗﺭﺍﻮﻛ ﺔﻠﺘﻛ",
  "block.minecraft.quartz_block": "ﺰﺗﺭﺍﻮﻜﻟﺍ ﻦﻣ ﺔﻠﺘﻛ",
  "block.minecraft.quartz_bricks": "ﺰﺗﺭﺍﻮﻜﻟﺍ ﺏﻮﻃ",
  "block.minecraft.quartz_pillar": "ﺰﺗﺭﺍﻮﻛ ﺩﻮﻤﻋ",
  "block.minecraft.quartz_stairs": "ﺰﺗﺭﺍﻮﻛ ﺝﺭﺩ",
  "block.minecraft.activator_rail": "ﺔﻠﹻﹽﻌﻔﻣ ﺔﻳﺪﻳﺪﺣ ﺔﻜﺳ",
  "block.minecraft.dropper": "ﺓﺭﺎﻄﻗ",
  "block.minecraft.white_terracotta": "ﺾﻴﺑﻷﺍ ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.orange_terracotta": "ﻲﻟﺎﻘﺗﺮﺒﻟﺍ ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.magenta_terracotta": "ﻲﻧﺍﻮﺟﺭﻷﺍ ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.light_blue_terracotta": "ﺢﺗﺎﻔﻟﺍ ﻕﺭﺯﻷﺍ ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.yellow_terracotta": "ﺮﻔﺻﻷﺍ ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.lime_terracotta": "ﻲﻧﻮﻤﻴﻠﻟﺍ ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.pink_terracotta": "ﻱﺩﺭﻮﻟﺍ ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.gray_terracotta": "ﻱﺩﺎﻣﺮﻟﺍ ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.light_gray_terracotta": "ﺢﺗﺎﻔﻟﺍ ﻱﺩﺎﻣﺮﻟﺍ ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.cyan_terracotta": "ﻱﻭﺎﻤﺴﻟﺍ ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.purple_terracotta": "ﻲﺠﺴﻔﻨﺒﻟﺍ ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.blue_terracotta": "ﻕﺭﺯﻷﺍ ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.brown_terracotta": "ﻲﻨﺒﻟﺍ ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.green_terracotta": "ﺮﻀﺧﻷﺍ ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.red_terracotta": "ﺮﻤﺣﻷﺍ ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.black_terracotta": "ﺩﻮﺳﻷﺍ ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.barrier": "ﺰﺟﺎﺣ",
  "block.minecraft.iron_trapdoor": "ﻱﺪﻳﺪﺣ ﻲﺿﺭﺃ ﺏﺎﺑ",
  "block.minecraft.hay_block": "ﺶﻗ ﺔﻣﻮﻛ",
  "block.minecraft.white_carpet": "ﺾﻴﺑﺃ ﺩﺎﺠﺳ",
  "block.minecraft.orange_carpet": "ﻲﻟﺎﻘﺗﺮﺑ ﺩﺎﺠﺳ",
  "block.minecraft.magenta_carpet": "ﻲﻧﺍﻮﺟﺭﺃ ﺩﺎﺠﺳ",
  "block.minecraft.light_blue_carpet": "ﺢﺗﺎﻔﻟﺍ ﻕﺭﺯﺃ ﺩﺎﺠﺳ",
  "block.minecraft.yellow_carpet": "ﺮﻔﺻﺃ ﺩﺎﺠﺳ",
  "block.minecraft.lime_carpet": "ﻲﻧﻮﻤﻴﻟ ﺩﺎﺠﺳ",
  "block.minecraft.pink_carpet": "ﻱﺩﺭﻭ ﺩﺎﺠﺳ",
  "block.minecraft.gray_carpet": "ﻱﺩﺎﻣﺭ ﺩﺎﺠﺳ",
  "block.minecraft.light_gray_carpet": "ﺢﺗﺎﻓ ﻱﺩﺎﻣﺭ ﺩﺎﺠﺳ",
  "block.minecraft.cyan_carpet": "ﻱﻭﺎﻤﺳ ﺩﺎﺠﺳ",
  "block.minecraft.purple_carpet": "ﻲﺠﺴﻔﻨﺑ ﺩﺎﺠﺳ",
  "block.minecraft.blue_carpet": "ﻕﺭﺯﺃ ﺩﺎﺠﺳ",
  "block.minecraft.brown_carpet": "ﻲﻨﺑ ﺩﺎﺠﺳ",
  "block.minecraft.green_carpet": "ﺮﻀﺧﺃ ﺩﺎﺠﺳ",
  "block.minecraft.red_carpet": "ﺮﻤﺣﺃ ﺩﺎﺠﺳ",
  "block.minecraft.black_carpet": "ﺩﻮﺳﺃ ﺩﺎﺠﺳ",
  "block.minecraft.terracotta": "ﺞﻴﻀﻨﻟﺍ ﻦﻴﻃ",
  "block.minecraft.coal_block": "ﻢﺤﻔﻟﺍ ﻦﻣ ﺔﻠﺘﻛ",
  "block.minecraft.packed_ice": "ﺄﺒﻌﻣ ﺪﻴﻠﺟ",
  "block.minecraft.acacia_stairs": "ﻂﻨﺴﻟﺍ ﺝﺭﺩ",
  "block.minecraft.dark_oak_stairs": "ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﺝﺭﺩ",
  "block.minecraft.slime_block": "ﺝﺰﻠﻟﺍ ﺔﻠﺘﻛ",
  "block.minecraft.grass_path": "ﻲﺒﺸﻋ ﻖﻳﺮﻃ",
  "block.minecraft.sunflower": "ﺲﻤﺸﻟﺍ ﺩﺎﺒﻋ",
  "block.minecraft.lilac": "ﻚﻠﻴﻟ",
  "block.minecraft.rose_bush": "ﺩﺭﻭ ﺓﺮﻴﺠﺷ",
  "block.minecraft.peony": "ﺐﻴﻠﺼﻟﺍ ﺩﻮﻋ",
  "block.minecraft.tall_grass": "ﻞﻳﻮﻃ ﺐﺸﻋ",
  "block.minecraft.large_fern": "ﺓﺮﻴﺒﻛ ﺲﺧﺮﺳ",
  "block.minecraft.white_stained_glass": "ﺾﻴﺑﺍ ﺝﺎﺟﺯ",
  "block.minecraft.orange_stained_glass": "ﻲﻟﺎﻘﺗﺮﺑ ﺝﺎﺟﺯ",
  "block.minecraft.magenta_stained_glass": "ﻲﻧﺍﻮﺟﺭﺃ ﺝﺎﺟﺯ",
  "block.minecraft.light_blue_stained_glass": "ﺢﺗﺎﻓ ﻕﺭﺯﺍ ﺝﺎﺟﺯ",
  "block.minecraft.yellow_stained_glass": "ﺮﻔﺻﺍ ﺝﺎﺟﺯ",
  "block.minecraft.lime_stained_glass": "ﻲﻧﻮﻤﻴﻟ ﺝﺎﺟﺯ",
  "block.minecraft.pink_stained_glass": "ﻱﺩﺭﻭ ﺝﺎﺟﺯ",
  "block.minecraft.gray_stained_glass": "ﻱﺩﺎﻣﺭ ﺝﺎﺟﺯ",
  "block.minecraft.light_gray_stained_glass": "ﺢﺗﺎﻓ ﻱﺩﺎﻣﺭ ﺝﺎﺟﺯ",
  "block.minecraft.cyan_stained_glass": "ﻱﻭﺎﻤﺳ ﺝﺎﺟﺯ",
  "block.minecraft.purple_stained_glass": "ﻲﺠﺴﻔﻨﺑ ﺝﺎﺟﺯ",
  "block.minecraft.blue_stained_glass": "ﻕﺭﺯﺍ ﺝﺎﺟﺯ",
  "block.minecraft.brown_stained_glass": "ﻲﻨﺑ ﺝﺎﺟﺯ",
  "block.minecraft.green_stained_glass": "ﺮﻀﺧﺍ ﺝﺎﺟﺯ",
  "block.minecraft.red_stained_glass": "ﺮﻤﺣﺃ ﺝﺎﺟﺯ",
  "block.minecraft.black_stained_glass": "ﺩﻮﺳﺍ ﺝﺎﺟﺯ",
  "block.minecraft.white_stained_glass_pane": "ﺾﻴﺑﺃ ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.orange_stained_glass_pane": "ﻲﻟﺎﻘﺗﺮﺑ ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.magenta_stained_glass_pane": "ﻲﻧﺍﻮﺟﺭﺃ ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.light_blue_stained_glass_pane": "ﻱﻭﺎﻤﺳ ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.yellow_stained_glass_pane": "ﺮﻔﺻﺃ ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.lime_stained_glass_pane": "ﻲﻧﻮﻤﻴﻟ ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.pink_stained_glass_pane": "ﻱﺩﺭﻭ ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.gray_stained_glass_pane": "ﻱﺩﺎﻣﺭ ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.light_gray_stained_glass_pane": "ﺢﺗﺎﻓ ﻱﺩﺎﻣﺭ ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.cyan_stained_glass_pane": "ﻱﻭﺎﻤﺳ ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.purple_stained_glass_pane": "ﻲﺠﺴﻔﻨﺑ ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.blue_stained_glass_pane": "ﻕﺭﺯﺃ ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.brown_stained_glass_pane": "ﻲﻨﺑ ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.green_stained_glass_pane": "ﺮﻀﺧﺃ ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.red_stained_glass_pane": "ﺮﻤﺣﺃ ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.black_stained_glass_pane": "ﺩﻮﺳﺃ ﻲﺟﺎﺟﺯ ﺡﻮﻟ",
  "block.minecraft.prismarine": "ﻦﻳﺭﺎﻤﺴﻳﺮﺑ",
  "block.minecraft.prismarine_bricks": "ﻦﻳﺭﺎﻤﺴﻳﺮﺒﻟﺍ ﺏﻮﻃ",
  "block.minecraft.dark_prismarine": "ﻦﻛﺍﺩ ﻦﻳﺭﺎﻤﺴﻳﺮﺑ",
  "block.minecraft.prismarine_stairs": "ﻦﻳﺭﺎﻤﺴﻳﺮﺑ ﺝﺭﺩ",
  "block.minecraft.prismarine_brick_stairs": "ﻦﻳﺭﺎﻤﺴﻳﺮﺒﻟﺍ ﺏﻮﻃ ﺝﺭﺩ",
  "block.minecraft.dark_prismarine_stairs": "ﻦﻛﺍﺪﻟﺍ ﻦﻳﺭﺎﻤﺴﻳﺮﺒﻟﺍ ﺝﺭﺩ",
  "block.minecraft.sea_lantern": "ﺮﺤﺒﻟﺍ ﺡﺎﺒﺼﻣ",
  "block.minecraft.red_sandstone": "ﺮﻤﺣﺃ ﻲﻠﻣﺭ ﺮﺠﺣ",
  "block.minecraft.chiseled_red_sandstone": "ﺵﻮﻘﻨﻣ ﺮﻤﺣﺃ ﻲﻠﻣﺭ ﺮﺠﺣ",
  "block.minecraft.cut_red_sandstone": "ﻊﻄﻘﻣ ﺮﻤﺣﺃ ﻲﻠﻣﺭ ﺮﺠﺣ",
  "block.minecraft.red_sandstone_stairs": "ﺮﻤﺣﺃ ﻲﻠﻣﺭ ﺮﺠﺣ ﺝﺭﺩ",
  "block.minecraft.repeating_command_block": "ﺓﺭﹺﹼﺮﻜﻤﻟﺍ ﺮﻣﺍﻭﻷﺍ ﺔﻠﺘﻛ",
  "block.minecraft.chain_command_block": "ﺮﻣﺍﻭﻻﺍ ﺕﺍﺭﺪﺼﻣ ﻞﻴﺻﻮﺗ",
  "block.minecraft.magma_block": "ﺓﺭﺎﻬﺼﻟﺍ ﺔﻠﺘﻛ",
  "block.minecraft.nether_wart_block": "ﺭﺬﻨﻟﺍ ﻝﻮﻟﺆﺛ ﺔﻠﺘﻛ",
  "block.minecraft.warped_wart_block": "ﺔﺒﻴﺠﻋ ﻝﻮﻟﺆﺛ ﺔﻠﺘﻛ",
  "block.minecraft.red_nether_bricks": "ﺮﻤﺣﻷﺍ ﺭﺬﻨﻟﺍ ﺏﻮﻃ",
  "block.minecraft.bone_block": "ﻡﺎﻈﻋ ﺔﻠﺘﻛ",
  "block.minecraft.structure_void": "ﻞﻜﻴﻬﻟﺍ ﻍﺍﺮﻓ",
  "block.minecraft.observer": "ﺐﻗﺍﺮﻤﻟﺍ",
  "block.minecraft.shulker_box": "ﺮﻜﻠﺸﻟﺍ ﻕﻭﺪﻨﺻ",
  "block.minecraft.white_shulker_box": "ﺾﻴﺑﺃ ﺮﻜﻠﺷ ﻕﻭﺪﻨﺻ",
  "block.minecraft.orange_shulker_box": "ﻲﻟﺎﻘﺗﺮﺑ ﺮﻜﻠﺷ ﻕﻭﺪﻨﺻ",
  "block.minecraft.magenta_shulker_box": "ﻲﻧﺍﻮﺟﺭﺃ ﺮﻜﻠﺷ ﻕﻭﺪﻨﺻ",
  "block.minecraft.light_blue_shulker_box": "ﺢﺗﺎﻓ ﻕﺭﺯﺃ ﺮﻜﻠﺷ ﻕﻭﺪﻨﺻ",
  "block.minecraft.yellow_shulker_box": "ﺮﻔﺻﺃ ﺮﻜﻠﺷ ﻕﻭﺪﻨﺻ",
  "block.minecraft.lime_shulker_box": "ﻲﻧﻮﻤﻴﻟ ﺮﻜﻠﺷ ﻕﻭﺪﻨﺻ",
  "block.minecraft.pink_shulker_box": "ﻱﺮﻫﺯ ﺮﻜﻠﺷ ﻕﻭﺪﻨﺻ",
  "block.minecraft.gray_shulker_box": "ﻱﺩﺎﻣﺭ ﺮﻜﻠﺷ ﻕﻭﺪﻨﺻ",
  "block.minecraft.light_gray_shulker_box": "ﺢﺗﺎﻓ ﻱﺩﺎﻣﺭ ﺮﻜﻠﺷ ﻕﻭﺪﻨﺻ",
  "block.minecraft.cyan_shulker_box": "ﻱﻭﺎﻤﺳ ﺮﻜﻠﺷ ﻕﻭﺪﻨﺻ",
  "block.minecraft.purple_shulker_box": "ﻲﺠﺴﻔﻨﺑ ﺮﻜﻠﺷ ﻕﻭﺪﻨﺻ",
  "block.minecraft.blue_shulker_box": "ﻕﺭﺯﺃ ﺮﻜﻠﺷ ﻕﻭﺪﻨﺻ",
  "block.minecraft.brown_shulker_box": "ﻲﻨﺑ ﺮﻜﻠﺷ ﻕﻭﺪﻨﺻ",
  "block.minecraft.green_shulker_box": "ﺮﻀﺧﺃ ﺮﻜﻠﺷ ﻕﻭﺪﻨﺻ",
  "block.minecraft.red_shulker_box": "ﺮﻤﺣﺃ ﺮﻜﻠﺷ ﻕﻭﺪﻨﺻ",
  "block.minecraft.black_shulker_box": "ﺩﻮﺳﺃ ﺮﻜﻠﺷ ﻕﻭﺪﻨﺻ",
  "block.minecraft.white_glazed_terracotta": "ﺾﻴﺑﻷﺍ ﺞﺟﺰﻤﻟﺍ ﻦﻴﻃ",
  "block.minecraft.orange_glazed_terracotta": "ﻲﻟﺎﻘﺗﺮﺒﻟﺍ ﺞﺟﺰﻤﻟﺍ ﻦﻴﻃ",
  "block.minecraft.magenta_glazed_terracotta": "ﻲﻧﺍﻮﺟﺭﻷﺍ ﺞﺟﺰﻤﻟﺍ ﻦﻴﻃ",
  "block.minecraft.light_blue_glazed_terracotta": "ﺢﺗﺎﻔﻟﺍ ﻕﺭﺯﻷﺍ ﺞﺟﺰﻤﻟﺍ ﻦﻴﻃ",
  "block.minecraft.yellow_glazed_terracotta": "ﺮﻔﺻﻷﺍ ﺞﺟﺰﻤﻟﺍ ﻦﻴﻃ",
  "block.minecraft.lime_glazed_terracotta": "ﻲﻧﻮﻤﻴﻠﻟﺍ ﺞﺟﺰﻤﻟﺍ ﻦﻴﻃ",
  "block.minecraft.pink_glazed_terracotta": "ﻱﺩﺭﻮﻟﺍ ﺞﺟﺰﻤﻟﺍ ﻦﻴﻃ",
  "block.minecraft.gray_glazed_terracotta": "ﻱﺩﺎﻣﺮﻟﺍ ﺞﺟﺰﻤﻟﺍ ﻦﻴﻃ",
  "block.minecraft.light_gray_glazed_terracotta": "ﺢﺗﺎﻔﻟﺍ ﻱﺩﺎﻣﺮﻟﺍ ﺞﺟﺰﻤﻟﺍ ﻦﻴﻃ",
  "block.minecraft.cyan_glazed_terracotta": "ﻱﻭﺎﻤﺴﻟﺍ ﺞﺟﺰﻤﻟﺍ ﻦﻴﻃ",
  "block.minecraft.purple_glazed_terracotta": "ﻲﺠﺴﻔﻨﺑ ﺞﺟﺰﻣ ﻦﻴﻃ",
  "block.minecraft.blue_glazed_terracotta": "ﻕﺭﺯﻷﺍ ﺞﺟﺰﻤﻟﺍ ﻦﻴﻃ",
  "block.minecraft.brown_glazed_terracotta": "ﻲﻨﺒﻟﺍ ﺞﺟﺰﻤﻟﺍ ﻦﻴﻃ",
  "block.minecraft.green_glazed_terracotta": "ﺮﻀﺧﻷﺍ ﺞﺟﺰﻤﻟﺍ ﻦﻴﻃ",
  "block.minecraft.red_glazed_terracotta": "ﺮﻤﺣﻷﺍ ﺞﺟﺰﻤﻟﺍ ﻦﻴﻃ",
  "block.minecraft.black_glazed_terracotta": "ﺩﻮﺳﻷﺍ ﺞﺟﺰﻤﻟﺍ ﻦﻴﻃ",
  "block.minecraft.white_concrete": "ﺾﻴﺑﺃ ﺖﻨﻤﺳﺃ",
  "block.minecraft.orange_concrete": "ﻲﻟﺎﻘﺗﺮﺑ ﺖﻨﻤﺳﺃ",
  "block.minecraft.magenta_concrete": "ﻲﻧﺍﻮﺟﺭﺃ ﺖﻨﻤﺳﺃ",
  "block.minecraft.light_blue_concrete": "ﺢﺗﺎﻓ ﻕﺭﺯﺃ ﺖﻨﻤﺳﺃ",
  "block.minecraft.yellow_concrete": "ﺮﻔﺻﺃ ﺖﻨﻤﺳﺃ",
  "block.minecraft.lime_concrete": "ﻲﻧﻮﻤﻴﻟ ﺖﻨﻤﺳﺃ",
  "block.minecraft.pink_concrete": "ﻱﺩﺭﻭ ﺖﻨﻤﺳﺃ",
  "block.minecraft.gray_concrete": "ﻱﺩﺎﻣﺭ ﺖﻨﻤﺳﻻﺍ",
  "block.minecraft.light_gray_concrete": "ﺢﺗﺎﻓ ﻱﺩﺎﻣﺭ ﺖﻨﻤﺳﺃ",
  "block.minecraft.cyan_concrete": "ﻱﻭﺎﻤﺳ ﺖﻨﻤﺳﺃ",
  "block.minecraft.purple_concrete": "ﻲﺠﺴﻔﻨﺑ ﺖﻨﻤﺳﺃ",
  "block.minecraft.blue_concrete": "ﻕﺭﺯﺃ ﺖﻨﻤﺳﺃ",
  "block.minecraft.brown_concrete": "ﻲﻨﺑ ﺖﻨﻤﺳﺃ",
  "block.minecraft.green_concrete": "ﺮﻀﺧﺃ ﺖﻨﻤﺳﺃ",
  "block.minecraft.red_concrete": "ﺮﻤﺣﺃ ﺖﻨﻤﺳﺃ",
  "block.minecraft.black_concrete": "ﺩﻮﺳﺃ ﺖﻨﻤﺳﺃ",
  "block.minecraft.white_concrete_powder": "ﺾﻴﺑﺃ ﺖﻨﻤﺳﺃ ﻕﻮﺤﺴﻣ",
  "block.minecraft.orange_concrete_powder": "ﻲﻟﺎﻘﺗﺮﺑ ﺖﻨﻤﺳﺃ ﻕﻮﺤﺴﻣ",
  "block.minecraft.magenta_concrete_powder": "ﻲﻧﺍﻮﺟﺭﺃ ﺖﻨﻤﺳﺃ ﻕﻮﺤﺴﻣ",
  "block.minecraft.light_blue_concrete_powder": "ﺢﺗﺎﻓ ﻕﺭﺯﺃ ﺖﻨﻤﺳﺃ ﻕﻮﺤﺴﻣ",
  "block.minecraft.yellow_concrete_powder": "ﺮﻔﺻﺃ ﺖﻨﻤﺳﺃ ﻕﻮﺤﺴﻣ",
  "block.minecraft.lime_concrete_powder": "ﻲﻧﻮﻤﻴﻟ ﺖﻨﻤﺳﺃ ﻕﻮﺤﺴﻣ",
  "block.minecraft.pink_concrete_powder": "ﻱﺩﺭﻭ ﺖﻨﻤﺳﺃ ﻕﻮﺤﺴﻣ",
  "block.minecraft.gray_concrete_powder": "ﻱﺩﺎﻣﺭ ﺖﻨﻤﺳﺃ ﻕﻮﺤﺴﻣ",
  "block.minecraft.light_gray_concrete_powder": "ﺢﺗﺎﻓ ﻱﺩﺎﻣﺭ ﺖﻨﻤﺳﺃ ﻕﻮﺤﺴﻣ",
  "block.minecraft.cyan_concrete_powder": "ﻱﻭﺎﻤﺳ ﺖﻨﻤﺳﺃ ﻕﻮﺤﺴﻣ",
  "block.minecraft.purple_concrete_powder": "ﻲﺠﺴﻔﻨﺑ ﺖﻨﻤﺳﺃ ﻕﻮﺤﺴﻣ",
  "block.minecraft.blue_concrete_powder": "ﻕﺭﺯﺃ ﺖﻨﻤﺳﺃ ﻕﻮﺤﺴﻣ",
  "block.minecraft.brown_concrete_powder": "ﻲﻨﺑ ﺖﻨﻤﺳﺃ ﻕﻮﺤﺴﻣ",
  "block.minecraft.green_concrete_powder": "ﺮﻀﺧﺃ ﺖﻨﻤﺳﺃ ﻕﻮﺤﺴﻣ",
  "block.minecraft.red_concrete_powder": "ﺮﻤﺣﺃ ﺖﻨﻤﺳﺃ ﻕﻮﺤﺴﻣ",
  "block.minecraft.black_concrete_powder": "ﺩﻮﺳﺃ ﺖﻨﻤﺳﺃ ﻕﻮﺤﺴﻣ",
  "block.minecraft.turtle_egg": "ﺓﺎﻔﺤﻠﺳ ﺔﻀﻴﺑ",
  "block.minecraft.dead_tube_coral_block": "ﺖﻴﻣ ﻲﺑﻮﺒﻧﺃ ﻥﺎﺟﺮﻣ ﺔﻠﺘﻛ",
  "block.minecraft.dead_brain_coral_block": "ﺖﻴﻣ ﻲﻠﻘﻋ ﻥﺎﺟﺮﻣ ﺔﻠﺘﻛ",
  "block.minecraft.dead_bubble_coral_block": "ﺖﻴﻣ ﻲﻋﺎﻘﻓ ﻥﺎﺟﺮﻣ ﺔﻠﺘﻛ",
  "block.minecraft.dead_fire_coral_block": "ﺖﻴﻣ ﻱﺭﺎﻧ ﻥﺎﺟﺮﻣ ﺔﻠﺘﻛ",
  "block.minecraft.dead_horn_coral_block": "ﺖﻴﻣ ﻲﻗﻮﺑ ﻥﺎﺟﺮﻣ ﺔﻠﺘﻛ",
  "block.minecraft.tube_coral_block": "ﻲﺑﻮﺒﻧﺃ ﻥﺎﺟﺮﻣ ﺔﻠﺘﻛ",
  "block.minecraft.brain_coral_block": "ﻲﻠﻘﻋ ﻥﺎﺟﺮﻣ ﺔﻠﺘﻛ",
  "block.minecraft.bubble_coral_block": "ﻲﻋﺎﻘﻓ ﻥﺎﺟﺮﻣ ﺔﻠﺘﻛ",
  "block.minecraft.fire_coral_block": "ﻱﺭﺎﻧ ﻥﺎﺟﺮﻣ ﺔﻠﺘﻛ",
  "block.minecraft.horn_coral_block": "ﻲﻗﻮﺑ ﻥﺎﺟﺮﻣ ﺔﻠﺘﻛ",
  "block.minecraft.tube_coral": "ﻲﺑﻮﺒﻧﺃ ﻥﺎﺟﺮﻣ",
  "block.minecraft.brain_coral": "ﻲﻠﻘﻋ ﻥﺎﺟﺮﻣ",
  "block.minecraft.bubble_coral": "ﻲﻋﺎﻘﻓ ﻥﺎﺟﺮﻣ",
  "block.minecraft.fire_coral": "ﻱﺭﺎﻧ ﻥﺎﺟﺮﻣ",
  "block.minecraft.horn_coral": "ﻲﻗﻮﺑ ﻥﺎﺟﺮﻣ",
  "block.minecraft.dead_brain_coral": "ﺖﻴﻣ ﻲﻠﻘﻋ ﻥﺎﺟﺮﻣ",
  "block.minecraft.dead_bubble_coral": "ﺖﻴﻣ ﻲﻋﺎﻘﻓ ﻥﺎﺟﺮﻣ",
  "block.minecraft.dead_fire_coral": "ﺖﻴﻣ ﻱﺭﺎﻧ ﻥﺎﺟﺮﻣ",
  "block.minecraft.dead_horn_coral": "ﺖﻴﻣ ﻲﻗﻮﺑ ﻥﺎﺟﺮﻣ",
  "block.minecraft.dead_tube_coral": "ﺖﻴﻣ ﻲﺑﻮﺒﻧﺃ ﻥﺎﺟﺮﻣ",
  "block.minecraft.tube_coral_fan": "ﻲﺑﻮﺒﻧﺃ ﻥﺎﺟﺮﻣ ﺏﺎﻌﺷ",
  "block.minecraft.brain_coral_fan": "ﻲﻠﻘﻋ ﻥﺎﺟﺮﻣ ﺏﺎﻌﺷ",
  "block.minecraft.bubble_coral_fan": "ﻲﻋﺎﻘﻓ ﻥﺎﺟﺮﻣ ﺏﺎﻌﺷ",
  "block.minecraft.fire_coral_fan": "ﻱﺭﺎﻧ ﻥﺎﺟﺮﻣ ﺏﺎﻌﺷ",
  "block.minecraft.horn_coral_fan": "ﻲﻗﻮﺑ ﻥﺎﺟﺮﻣ ﺏﺎﻌﺷ",
  "block.minecraft.dead_tube_coral_fan": "ﺖﻴﻣ ﻲﺑﻮﺒﻧﺃ ﻥﺎﺟﺮﻣ ﺏﺎﻌﺷ",
  "block.minecraft.dead_brain_coral_fan": "ﺖﻴﻣ ﻲﻠﻘﻋ ﻥﺎﺟﺮﻣ ﺏﺎﻌﺷ",
  "block.minecraft.dead_bubble_coral_fan": "ﺖﻴﻣ ﻲﻋﺎﻘﻓ ﻥﺎﺟﺮﻣ ﺏﺎﻌﺷ",
  "block.minecraft.dead_fire_coral_fan": "ﺖﻴﻣ ﻱﺭﺎﻧ ﻥﺎﺟﺮﻣ ﺏﺎﻌﺷ",
  "block.minecraft.dead_horn_coral_fan": "ﺖﻴﻣ ﻲﻧﺮﻗ ﻥﺎﺟﺮﻣ ﺏﺎﻌﺷ",
  "block.minecraft.blue_ice": "ﻕﺭﺯﺃ ﺪﻴﻠﺟ",
  "block.minecraft.conduit": "ﻂﻴﺤﻤﻟﺍ ﺓﺍﻮﻧ",
  "block.minecraft.polished_granite_stairs": "ﻝﻮﻘﺼﻣ ﺖﻴﻧﺍﺮﺟ ﺝﺭﺩ",
  "block.minecraft.smooth_red_sandstone_stairs": "ﺲﻠﻣﺃ ﺮﻤﺣﺃ ﻲﻠﻣﺭ ﺮﺠﺣ ﺝﺭﺩ",
  "block.minecraft.mossy_stone_brick_stairs": "ﺐﻠﺤﻄﻣ ﻱﺮﺠﺣ ﺏﻮﻃ ﺝﺭﺩ",
  "block.minecraft.polished_diorite_stairs": "ﻝﻮﻘﺼﻣ ﺖﻳﺭﻮﻳﺩ ﺝﺭﺩ",
  "block.minecraft.mossy_cobblestone_stairs": "ﺔﺒﺤﻠﻄﻤﻟﺍ ﻒﺻﺮﻟﺍ ﺓﺎﺼﺣ ﺝﺭﺩ",
  "block.minecraft.end_stone_brick_stairs": "ﺪﻧﻻﺍ ﺮﺠﺣ ﺏﻮﻃ ﺝﺭﺩ",
  "block.minecraft.stone_stairs": "ﻱﺮﺠﺣ ﺝﺭﺩ",
  "block.minecraft.smooth_sandstone_stairs": "ﺲﻠﻣﺃ ﻲﻠﻣﺭ ﺮﺠﺣ ﺝﺭﺩ",
  "block.minecraft.smooth_quartz_stairs": "ﻢﻋﺎﻧ ﺰﺗﺭﺍﻮﻛ ﺝﺭﺩ",
  "block.minecraft.granite_stairs": "ﺖﻴﻧﺍﺮﺟ ﺝﺭﺩ",
  "block.minecraft.andesite_stairs": "ﺖﻳﺎﺴﻳﺪﻧﺃ ﺝﺭﺩ",
  "block.minecraft.red_nether_brick_stairs": "ﺮﻤﺣﻷﺍ ﺭﺬﻨﻟﺍ ﺏﻮﻃ ﺝﺭﺩ",
  "block.minecraft.polished_andesite_stairs": "ﻝﻮﻘﺼﻣ ﺖﻳﺎﺴﻳﺪﻧﺃ ﺝﺭﺩ",
  "block.minecraft.diorite_stairs": "ﺖﻳﺭﻮﻳﺩ ﺝﺭﺩ",
  "block.minecraft.polished_granite_slab": "ﻝﻮﻘﺼﻣ ﺖﻴﻧﺍﺮﺟ ﺔﻃﻼﺑ",
  "block.minecraft.smooth_red_sandstone_slab": "ﺲﻠﻣﺃ ﺮﻤﺣﺃ ﻲﻠﻣﺭ ﺮﺠﺣ ﺔﻃﻼﺑ",
  "block.minecraft.mossy_stone_brick_slab": "ﺐﻠﺤﻄﻣ ﻱﺮﺠﺣ ﺏﻮﻃ ﺔﻃﻼﺑ",
  "block.minecraft.polished_diorite_slab": "ﻝﻮﻘﺼﻣ ﺖﻳﺭﻮﻳﺩ ﺔﻃﻼﺑ",
  "block.minecraft.mossy_cobblestone_slab": "ﺔﺒﺤﻠﻄﻤﻟﺍ ﻒﺻﺮﻟﺍ ﺓﺎﺼﺣ ﺔﻃﻼﺑ",
  "block.minecraft.end_stone_brick_slab": "ﺪﻧﻻﺍ ﺮﺠﺣ ﺏﻮﻃ ﺔﻃﻼﺑ",
  "block.minecraft.smooth_sandstone_slab": "ﺲﻠﻣﺃ ﻲﻠﻣﺭ ﺮﺠﺣ ﺔﻃﻼﺑ",
  "block.minecraft.smooth_quartz_slab": "ﺔﻤﻋﺎﻧ ﺰﺗﺭﺍﻮﻛ ﺔﻃﻼﺑ",
  "block.minecraft.granite_slab": "ﺖﻴﻧﺍﺮﺟ ﺔﻃﻼﺑ",
  "block.minecraft.andesite_slab": "ﺖﻳﺎﺴﻳﺪﻧﺃ ﺔﻃﻼﺑ",
  "block.minecraft.red_nether_brick_slab": "ﺮﻤﺣﻷﺍ ﺭﺬﻨﻟﺍ ﺏﻮﻃ ﺔﻃﻼﺑ",
  "block.minecraft.polished_andesite_slab": "ﻝﻮﻘﺼﻣ ﺖﻳﺎﺴﻳﺪﻧﺃ ﺔﻃﻼﺑ",
  "block.minecraft.diorite_slab": "ﺖﻳﺭﻮﻳﺩ ﺔﻃﻼﺑ",
  "block.minecraft.scaffolding": "ﺔﻟﺎﻘﺳ",
  "block.minecraft.iron_door": "ﻱﺪﻳﺪﺣ ﺏﺎﺑ",
  "block.minecraft.oak_door": "ﻁﻮﻠﺒﻟﺍ ﺏﺎﺑ",
  "block.minecraft.spruce_door": "ﺏﻮﻨﺘﻟﺍ ﺏﺎﺑ",
  "block.minecraft.birch_door": "ﻻﻮﺘﺒﻟﺍ ﺏﺎﺑ",
  "block.minecraft.jungle_door": "ﺔﺑﺎﻐﻟﺍ ﺏﺎﺑ",
  "block.minecraft.acacia_door": "ﻂﻨﺴﻟﺍ ﺏﺎﺑ",
  "block.minecraft.dark_oak_door": "ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﺏﺎﺑ",
  "block.minecraft.crimson_door": "ﻱﺰﻣﺮﻗ ﺏﺎﺑ",
  "block.minecraft.warped_door": "ﺐﻴﺠﻋ ﺏﺎﺑ",
  "block.minecraft.repeater": "ﻥﻮﺘﺳﺪﻳﺮﻟﺍ ﺭﺮﻜﻣ",
  "block.minecraft.comparator": "ﻥﻮﺘﺳﺪﻳﺮﻟﺍ ﻥﺭﺎﻘﻣ",
  "block.minecraft.structure_block": "ﻞﻜﻴﻬﻟﺍ ﺔﻠﺘﻛ",
  "block.minecraft.jigsaw": "ﺔﻴﻣﺍﺭﻮﻧﺎﺑ ﺔﻠﺘﻛ",
  "item.minecraft.turtle_helmet": "ﺓﺎﻔﺤﻠﺳ ﺔﻓﺪﺻ□□:ﺱﺃﺮﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 2+",
  "item.minecraft.scute": "ﺓﺎﻔﺤﻠﺴﻟﺍ ﺔﻔﻳﺬﻗ",
  "item.minecraft.iron_shovel": "ﺔﻳﺪﻳﺪﺣ ﺔﻓﺮﺠﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 3.5+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 3-",
  "item.minecraft.iron_pickaxe": "ﻱﺪﻳﺪﺣ ﻝﻮﻌﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 3+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 2.8-",
  "item.minecraft.iron_axe": "ﻱﺪﻳﺪﺣ ﺱﺄﻓ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 8+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 3.1-",
  "item.minecraft.flint_and_steel": "ﻥﺍﻮﺻﻭ ﺪﻳﺪﺣ",
  "item.minecraft.apple": "ﺔﺣﺎﻔﺗ",
  "item.minecraft.bow": "ﺱﻮﻗ",
  "item.minecraft.arrow": "ﻢﻬﺳ",
  "item.minecraft.coal": "ﻢﺤﻓ",
  "item.minecraft.charcoal": "ﻲﺗﺎﺒﻧ ﻢﺤﻓ",
  "item.minecraft.diamond": "ﺱﺎﻤﻟﺃ",
  "item.minecraft.iron_ingot": "ﺪﻳﺪﺣ ﺔﻜﻴﺒﺳ",
  "item.minecraft.gold_ingot": "ﺐﻫﺫ ﺔﻜﻴﺒﺳ",
  "item.minecraft.netherite_ingot": "ﺖﻳﺍﺭﺬﻧ ﺔﻜﻴﺒﺳ",
  "item.minecraft.netherite_scrap": "ﺖﻳﺍﺭﺬﻧ ﺕﺎﺘﻓ",
  "item.minecraft.iron_sword": "ﻱﺪﻳﺪﺣ ﻒﻴﺳ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 5+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 2.4-",
  "item.minecraft.wooden_sword": "ﻲﺒﺸﺧ ﻒﻴﺳ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 3+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 2.4-",
  "item.minecraft.wooden_shovel": "ﺔﻴﺒﺸﺧ ﺔﻓﺮﺠﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 1.5+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 3-",
  "item.minecraft.wooden_pickaxe": "ﻲﺒﺸﺧ ﻝﻮﻌﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 1+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 2.8-",
  "item.minecraft.wooden_axe": "ﻲﺒﺸﺧ ﺱﺄﻓ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 6+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 3.2-",
  "item.minecraft.stone_sword": "ﻱﺮﺠﺣ ﻒﻴﺳ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 4+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 2.4-",
  "item.minecraft.stone_shovel": "ﺔﻳﺮﺠﺣ ﺔﻓﺮﺠﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 2.5+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 3-",
  "item.minecraft.stone_pickaxe": "ﻱﺮﺠﺣ ﻝﻮﻌﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 2+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 2.8-",
  "item.minecraft.stone_axe": "ﻱﺮﺠﺣ ﺱﺄﻓ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 8+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 3.2-",
  "item.minecraft.diamond_sword": "ﻲﺳﺎﻤﻟﺃ ﻒﻴﺳ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 6+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 2.4-",
  "item.minecraft.diamond_shovel": "ﺔﻴﺳﺎﻤﻟﺃ ﺔﻓﺮﺠﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 4.5+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 3-",
  "item.minecraft.diamond_pickaxe": "ﻲﺳﺎﻤﻟﺃ ﻝﻮﻌﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 4+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 2.8-",
  "item.minecraft.diamond_axe": "ﻲﺳﺎﻤﻟﺃ ﺱﺄﻓ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 8+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 3-",
  "item.minecraft.stick": "ﺎﺼﻋ",
  "item.minecraft.bowl": "ﺔﻳﺪﺑﺯ",
  "item.minecraft.mushroom_stew": "ﺮﻄﻔﻟﺍ ءﺎﺴﺣ",
  "item.minecraft.golden_sword": "ﻲﺒﻫﺫ ﻒﻴﺳ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 3+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 2.4-",
  "item.minecraft.golden_shovel": "ﺔﻴﺒﻫﺫ ﺔﻓﺮﺠﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 1.5+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 3-",
  "item.minecraft.golden_pickaxe": "ﻲﺒﻫﺫ ﻝﻮﻌﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 1+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 2.8-",
  "item.minecraft.golden_axe": "ﻲﺒﻫﺫ ﺱﺄﻓ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 6+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 3-",
  "item.minecraft.netherite_sword": "ﺖﻳﺍﺭﺬﻧ ﻒﻴﺳ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 7+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 2.4-",
  "item.minecraft.netherite_shovel": "ﺖﻳﺍﺭﺬﻧ ﺔﻓﺮﺠﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 5.5+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 3-",
  "item.minecraft.netherite_pickaxe": "ﺖﻳﺍﺭﺬﻧ ﻝﻮﻌﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 5+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 2.8-",
  "item.minecraft.netherite_axe": "ﺖﻳﺍﺭﺬﻧ ﺱﺄﻓ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 9+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 3-",
  "item.minecraft.string": "ﻂﻴﺧ",
  "item.minecraft.feather": "ﺔﺸﻳﺭ",
  "item.minecraft.gunpowder": "ﺩﻭﺭﺎﺑ",
  "item.minecraft.wooden_hoe": "ﺔﻴﺒﺸﺧ ﺔﻗﺰﻌﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 3-",
  "item.minecraft.stone_hoe": "ﺔﻳﺮﺠﺣ ﺔﻗﺰﻌﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 2-",
  "item.minecraft.iron_hoe": "ﺔﻳﺪﻳﺪﺣ ﺔﻗﺰﻌﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 1-",
  "item.minecraft.diamond_hoe": "ﺔﻴﺳﺎﻤﻟﺃ ﺔﻗﺰﻌﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ",
  "item.minecraft.golden_hoe": "ﺔﻴﺒﻫﺫ ﺔﻗﺰﻌﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 3-",
  "item.minecraft.netherite_hoe": "ﺖﻳﺍﺭﺬﻧ ﺔﻗﺰﻌﻣ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ",
  "item.minecraft.wheat_seeds": "ﺢﻤﻘﻟﺍ ﺭﻭﺬﺑ",
  "item.minecraft.wheat": "ﺢﻤﻗ",
  "item.minecraft.bread": "ﺰﺒﺧ",
  "item.minecraft.leather_helmet": "ﺔﻳﺪﻠﺟ ﺔﻌﺒﻗ□□:ﺱﺃﺮﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 1+",
  "item.minecraft.leather_chestplate": "ﺔﻳﺪﻠﺟ ﺓﺮﺘﺳ□□:ﻢﺴﺠﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 3+",
  "item.minecraft.leather_leggings": "ﻱﺪﻠﺟ ﻝﺍﻭﺮﺳ□□:ﻦﻴﻗﺎﺴﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 2+",
  "item.minecraft.leather_boots": "ﻱﺪﻠﺟ ءﺍﺬﺣ□□:ﻦﻴﻣﺪﻘﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 1+",
  "item.minecraft.chainmail_helmet": "ﺔﻳﺩﺭﺯ ﺓﺫﻮﺧ□□:ﺱﺃﺮﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 2+",
  "item.minecraft.chainmail_chestplate": "ﺔﻳﺩﺭﺯ ﺭﺪﺻ ﺔﺤﻴﻔﺻ□□:ﻢﺴﺠﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 5+",
  "item.minecraft.chainmail_leggings": "ﻱﺩﺭﺯ ﻝﺍﻭﺮﺳ□□:ﻦﻴﻗﺎﺴﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 4+",
  "item.minecraft.chainmail_boots": "ﻱﺩﺭﺯ ءﺍﺬﺣ□□:ﻦﻴﻣﺪﻘﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 1+",
  "item.minecraft.iron_helmet": "ﺔﻳﺪﻳﺪﺣ ﺓﺫﻮﺧ□□:ﺱﺃﺮﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 2+",
  "item.minecraft.iron_chestplate": "ﺔﻳﺪﻳﺪﺣ ﺭﺪﺻ ﺔﺤﻴﻔﺻ□□:ﻢﺴﺠﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 6+",
  "item.minecraft.iron_leggings": "ﻱﺪﻳﺪﺣ ﻝﺍﻭﺮﺳ□□:ﻦﻴﻗﺎﺴﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 5+",
  "item.minecraft.iron_boots": "ﻱﺪﻳﺪﺣ ءﺍﺬﺣ□□:ﻦﻴﻣﺪﻘﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 2+",
  "item.minecraft.diamond_helmet": "ﺔﻴﺳﺎﻤﻟﺃ ﺓﺫﻮﺧ□□:ﺱﺃﺮﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 3+□ﻉﺭﺪﻟﺍ ﺓﻮﻗ 2+",
  "item.minecraft.diamond_chestplate": "ﺔﻴﺳﺎﻤﻟﺃ ﺭﺪﺻ ﺔﺤﻴﻔﺻ□□:ﻢﺴﺠﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 8+□ﻉﺭﺪﻟﺍ ﺓﻮﻗ 2+",
  "item.minecraft.diamond_leggings": "ﻲﺳﺎﻤﻟﺃ ﻝﺍﻭﺮﺳ□□:ﻦﻴﻗﺎﺴﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 6+□ﻉﺭﺪﻟﺍ ﺓﻮﻗ 2+",
  "item.minecraft.diamond_boots": "ﻲﺳﺎﻤﻟﺃ ءﺍﺬﺣ□□:ﻦﻴﻣﺪﻘﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 3+□ﻉﺭﺪﻟﺍ ﺓﻮﻗ 2+",
  "item.minecraft.golden_helmet": "ﺔﻴﺒﻫﺫ ﺓﺫﻮﺧ□□:ﺱﺃﺮﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 2+",
  "item.minecraft.golden_chestplate": "ﺔﻴﺒﻫﺫ ﺭﺪﺻ ﺔﺤﻴﻔﺻ□□:ﻢﺴﺠﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 5+",
  "item.minecraft.golden_leggings": "ﻲﺒﻫﺫ ﻝﺍﻭﺮﺳ□□:ﻦﻴﻗﺎﺴﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 3+",
  "item.minecraft.golden_boots": "ﻲﺒﻫﺫ ءﺍﺬﺣ□□:ﻦﻴﻣﺪﻘﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 1+",
  "item.minecraft.netherite_helmet": "ﺖﻳﺍﺭﺬﻧ ﺓﺫﻮﺧ□□:ﺱﺃﺮﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 3+□ﻉﺭﺪﻟﺍ ﺓﻮﻗ 3+□ﺔﻣﻭﺎﻘﻤﻟﺍ ﻯﺮﺧﺃ ﺓﺮﻣ ﻕﺪﺗ 1+",
  "item.minecraft.netherite_chestplate": "ﺖﻳﺍﺭﺬﻧ ﺭﺪﺻ ﺔﺤﻴﻔﺻ□□:ﻢﺴﺠﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 8+□ﻉﺭﺪﻟﺍ ﺓﻮﻗ 3+□ﺔﻣﻭﺎﻘﻤﻟﺍ ﻯﺮﺧﺃ ﺓﺮﻣ ﻕﺪﺗ 1+",
  "item.minecraft.netherite_leggings": "ﺖﻳﺍﺭﺬﻧ ﻝﺍﻭﺮﺳ□□:ﻦﻴﻗﺎﺴﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 6+□ﻉﺭﺪﻟﺍ ﺓﻮﻗ 3+□ﺔﻣﻭﺎﻘﻤﻟﺍ ﻯﺮﺧﺃ ﺓﺮﻣ ﻕﺪﺗ 1+",
  "item.minecraft.netherite_boots": "ﺖﻳﺍﺭﺬﻧ ءﺍﺬﺣ□□:ﻦﻴﻣﺪﻘﻟﺍ ﻰﻠﻋ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻉﺭﺩ 3+□ﻉﺭﺪﻟﺍ ﺓﻮﻗ 3+□ﺔﻣﻭﺎﻘﻤﻟﺍ ﻯﺮﺧﺃ ﺓﺮﻣ ﻕﺪﺗ 1+",
  "item.minecraft.flint": "ﻥﺍﻮﺻ",
  "item.minecraft.porkchop": "ءﻲﻧ ﺮﻳﺰﻨﺧ ﻊﻠﺿ",
  "item.minecraft.cooked_porkchop": "ﺥﻮﺒﻄﻣ ﺮﻳﺰﻨﺧ ﻊﻠﺿ",
  "item.minecraft.painting": "ﺔﺣﻮﻟ",
  "item.minecraft.golden_apple": "ﺔﻴﺒﻫﺫ ﺔﺣﺎﻔﺗ",
  "item.minecraft.enchanted_golden_apple": "ﺓﺭﻮﺤﺴﻣ ﺔﻴﺒﻫﺫ ﺔﺣﺎﻔﺗ",
  "block.minecraft.oak_sign": "ﻁﻮﻠﺒﻟﺍ ﻦﻣ ﺔﺘﻓﻻ",
  "block.minecraft.spruce_sign": "ﺏﻮﻨﺘﻟﺍ ﺐﺸﺧ ﺔﺘﻓﻻ",
  "block.minecraft.birch_sign": "ﻻﻮﺘﺒﻟﺍ ﻦﻣ ﺔﺘﻓﻻ",
  "block.minecraft.jungle_sign": "ﻝﺎﻏﺩﻷﺍ ﻦﻣ ﺔﺘﻓﻻ",
  "block.minecraft.acacia_sign": "ﻂﻨﺴﻟﺍ ﻦﻣ ﺔﺘﻓﻻ",
  "block.minecraft.dark_oak_sign": "ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﻦﻣ ﺔﺘﻓﻻ",
  "block.minecraft.crimson_sign": "ﺔﻳﺰﻣﺮﻗ ﺔﺘﻓﻻ",
  "block.minecraft.warped_sign": "ﺔﺒﻴﺠﻋ ﺔﺘﻓﻻ",
  "item.minecraft.bucket": "ﻮﻟﺩ",
  "item.minecraft.water_bucket": "ءﺎﻣ ﻮﻟﺩ",
  "item.minecraft.lava_bucket": "ﺔﻴﻧﺎﻛﺮﺑ ﻢﻤﺣ ﻮﻟﺩ",
  "item.minecraft.minecart": "ﻢﺠﻨﻣ ﺔﺑﺮﻋ",
  "item.minecraft.saddle": "ﺝﺮﺳ",
  "item.minecraft.redstone": "ﻥﻮﺘﺳﺪﻳﺮﻟﺍ ﻕﻮﺤﺴﻣ",
  "item.minecraft.snowball": "ﺞﻠﺛ ﺓﺮﻛ",
  "item.minecraft.oak_boat": "ﻁﻮﻠﺒﻟﺍ ﺏﺭﺎﻗ",
  "item.minecraft.leather": "ﺪﻠﺟ",
  "item.minecraft.milk_bucket": "ﺐﻴﻠﺣ ﻮﻟﺩ",
  "item.minecraft.pufferfish_bucket": "ﺔﺨﻔﺘﻨﻣ ﺔﻜﻤﺳ ﻪﻴﻓ ﻮﻟﺩ",
  "item.minecraft.salmon_bucket": "ﻥﻮﻤﻠﺴﻟﺍ ﺔﻜﻤﺳ ﻪﻴﻓ ﻮﻟﺩ",
  "item.minecraft.cod_bucket": "ﺪﻘﻟﺍ ﺔﻜﻤﺳ ﻪﻴﻓ ﻮﻟﺩ",
  "item.minecraft.tropical_fish_bucket": "ﺔﻴﺋﺍﻮﺘﺳﺍ ﺔﻜﻤﺳ ﻪﻴﻓ ﻮﻟﺩ",
  "item.minecraft.brick": "ﺏﻮﻃ",
  "item.minecraft.clay_ball": "ﻝﺎﺼﻠﺻ ﺓﺮﻛ",
  "block.minecraft.dried_kelp_block": "ﻒﻔﺠﻤﻟﺍ ﺮﺤﺒﻟﺍ ﺐﺸﻋ ﺔﻠﺘﻛ",
  "item.minecraft.paper": "ﺔﻗﺭﻭ",
  "item.minecraft.book": "ﺏﺎﺘﻛ",
  "item.minecraft.slime_ball": "ﺔﺟﺰﻟ ﺓﺮﻛ",
  "item.minecraft.chest_minecart": "ﻕﻭﺪﻨﺼﺑ ﻢﺠﻨﻣ ﺔﺑﺮﻋ",
  "item.minecraft.furnace_minecart": "ﻥﺮﻔﺑ ﻢﺠﻨﻣ ﺔﺑﺮﻋ",
  "item.minecraft.egg": "ﺔﻀﻴﺑ",
  "item.minecraft.compass": "ﺔﻠﺻﻮﺑ",
  "item.minecraft.fishing_rod": "ﺪﻴﺻ ﺓﺭﺎﻨﺻ",
  "item.minecraft.clock": "ﺔﻋﺎﺳ",
  "item.minecraft.glowstone_dust": "ءﻲﻀﻤﻟﺍ ﺮﺠﺤﻟﺍ ﻕﻮﺤﺴﻣ",
  "item.minecraft.cod": "ءﻲﻧ ﺪﻗ ﻚﻤﺳ",
  "item.minecraft.salmon": "ءﻲﻧ ﻥﻮﻤﻠﺳ",
  "item.minecraft.tropical_fish": "ﺔﻴﺋﺍﻮﺘﺳﺍ ﺔﻜﻤﺳ",
  "item.minecraft.pufferfish": "ﺔﺨﻔﺘﻨﻣ ﺔﻜﻤﺳ",
  "item.minecraft.cooked_cod": "ﺥﻮﺒﻄﻣ ﺪﻗ ﻚﻤﺳ",
  "item.minecraft.cooked_salmon": "ﺥﻮﺒﻄﻣ ﻥﻮﻤﻠﺳ",
  "item.minecraft.ink_sac": "ﺮﺒﺣ ﺲﻴﻛ",
  "item.minecraft.red_dye": "ءﺍﺮﻤﺣ ﺔﻐﺒﺻ",
  "item.minecraft.green_dye": "ءﺍﺮﻀﺧ ﺔﻐﺒﺻ",
  "item.minecraft.cocoa_beans": "ﻭﺎﻛﺎﻜﻟﺍ ﺏﻮﺒﺣ",
  "item.minecraft.lapis_lazuli": "ﺩﺭﻭﺯﻻ",
  "item.minecraft.purple_dye": "ﺔﻴﺠﺴﻔﻨﺑ ﺔﻐﺒﺻ",
  "item.minecraft.cyan_dye": "ﺔﻳﻭﺎﻤﺳ ﺔﻐﺒﺻ",
  "item.minecraft.light_gray_dye": "ﺔﺤﺗﺎﻓ ﺔﻳﺩﺎﻣﺭ ﺔﻐﺒﺻ",
  "item.minecraft.gray_dye": "ﺔﻳﺩﺎﻣﺭ ﺔﻐﺒﺻ",
  "item.minecraft.pink_dye": "ﺔﻳﺩﺭﻭ ﺔﻐﺒﺻ",
  "item.minecraft.lime_dye": "ﺔﻴﻧﻮﻤﻴﻟ ﺔﻐﺒﺻ",
  "item.minecraft.yellow_dye": "ءﺍﺮﻔﺻ ﺔﻐﺒﺻ",
  "item.minecraft.light_blue_dye": "ﺔﺤﺗﺎﻓ ءﺎﻗﺭﺯ ﺔﻐﺒﺻ",
  "item.minecraft.magenta_dye": "ﺔﻴﻧﺍﻮﺟﺭﺃ ﺔﻐﺒﺻ",
  "item.minecraft.orange_dye": "ﺔﻴﻟﺎﻘﺗﺮﺑ ﺔﻐﺒﺻ",
  "item.minecraft.bone_meal": "ﻡﺎﻈﻌﻟﺍ ﻕﻮﺤﺴﻣ",
  "item.minecraft.blue_dye": "ءﺎﻗﺭﺯ ﺔﻐﺒﺻ",
  "item.minecraft.brown_dye": "ﺔﻴﻨﺑ ﺔﻐﺒﺻ",
  "item.minecraft.black_dye": "ءﺍﺩﻮﺳ ﺔﻐﺒﺻ",
  "item.minecraft.white_dye": "ءﺎﻀﻴﺑ ﺔﻐﺒﺻ",
  "item.minecraft.bone": "ﺔﻤﻈﻋ",
  "item.minecraft.sugar": "ﺮﻜﺳ",
  "block.minecraft.cake": "ﺔﻜﻌﻛ",
  "block.minecraft.white_bed": "ﺾﻴﺑﺃ ﺮﻳﺮﺳ",
  "block.minecraft.orange_bed": "ﻲﻟﺎﻘﺗﺮﺑ ﺮﻳﺮﺳ",
  "block.minecraft.magenta_bed": "ﻲﻧﺍﻮﺟﺭﺃ ﺮﻳﺮﺳ",
  "block.minecraft.light_blue_bed": "ﺢﺗﺎﻓ ﻕﺭﺯﺃ ﺮﻳﺮﺳ",
  "block.minecraft.yellow_bed": "ﺮﻔﺻﺃ ﺮﻳﺮﺳ",
  "block.minecraft.lime_bed": "ﻲﻧﻮﻤﻴﻟ ﺮﻳﺮﺳ",
  "block.minecraft.pink_bed": "ﻱﺩﺭﻭ ﺮﻳﺮﺳ",
  "block.minecraft.gray_bed": "ﻱﺩﺎﻣﺭ ﺮﻳﺮﺳ",
  "block.minecraft.light_gray_bed": "ﺢﺗﺎﻓ ﻱﺩﺎﻣﺭ ﺮﻳﺮﺳ",
  "block.minecraft.cyan_bed": "ﻱﻭﺎﻤﺳ ﺮﻳﺮﺳ",
  "block.minecraft.purple_bed": "ﻲﺠﺴﻔﻨﺑ ﺮﻳﺮﺳ",
  "block.minecraft.blue_bed": "ﻕﺭﺯﺃ ﺮﻳﺮﺳ",
  "block.minecraft.brown_bed": "ﻲﻨﺑ ﺮﻳﺮﺳ",
  "block.minecraft.green_bed": "ﺮﻀﺧﺃ ﺮﻳﺮﺳ",
  "block.minecraft.red_bed": "ﺮﻤﺣﺃ ﺮﻳﺮﺳ",
  "block.minecraft.black_bed": "ﺩﻮﺳﺃ ﺮﻳﺮﺳ",
  "item.minecraft.cookie": "ﺖﻳﻮﻜﺴﺑ",
  "item.minecraft.filled_map": "ﺔﻄﻳﺮﺧ□#0",
  "item.minecraft.shears": "ﺰﺠﻟﺍ ﺺﻘﻣ",
  "item.minecraft.melon_slice": "ﺦﻴﻄﺑ ﺔﻌﻄﻗ",
  "item.minecraft.dried_kelp": "ﻒﻔﺠﻤﻟﺍ ﺮﺤﺒﻟﺍ ﺐﺸﻋ",
  "item.minecraft.pumpkin_seeds": "ﻦﻴﻄﻘﻴﻟﺍ ﺭﻭﺬﺑ",
  "item.minecraft.melon_seeds": "ﺦﻴﻄﺒﻟﺍ ﺭﻭﺬﺑ",
  "item.minecraft.beef": "ءﻲﻧ ﺮﻘﺑ ﻢﺤﻟ",
  "item.minecraft.cooked_beef": "ﻢﺤﻟ ﺔﺤﻳﺮﺷ",
  "item.minecraft.chicken": "ءﻲﻧ ﺝﺎﺟﺩ",
  "item.minecraft.cooked_chicken": "ﺥﻮﺒﻄﻣ ﺝﺎﺟﺩ",
  "item.minecraft.rotten_flesh": "ﺪﺳﺎﻓ ﻢﺤﻟ",
  "item.minecraft.ender_pearl": "ﺭﺪﻧﻻﺍ ﺓﺆﻟﺆﻟ",
  "item.minecraft.blaze_rod": "ﺐﻬﻠﻟﺍ ﺎﺼﻋ",
  "item.minecraft.ghast_tear": "ﺢﺒﺸﻟﺍ ﺔﻌﻣﺩ",
  "item.minecraft.gold_nugget": "ﺔﻴﺒﻫﺫ ﺔﻌﻄﻗ",
  "item.minecraft.nether_wart": "ﺭﺬﻨﻟﺍ ﻝﻮﻟﺆﺛ",
  "item.minecraft.potion": "ﺔﻋﺎﻨﺼﻠﻟ ﺔﻠﺑﺎﻗ ﺮﻴﻏ ﺔﻋﺮﺟ□ﺕﺍﺮﻴﺛﺄﺗ ﻻ",
  "item.minecraft.glass_bottle": "ﺝﺎﺟﺯ ﺓﺭﻭﺭﺎﻗ",
  "item.minecraft.spider_eye": "ﺕﻮﺒﻜﻨﻌﻟﺍ ﻦﻴﻋ",
  "item.minecraft.fermented_spider_eye": "ﺓﺮﻤﺨﻤﻟﺍ ﺕﻮﺒﻜﻨﻌﻟﺍ ﻦﻴﻋ",
  "item.minecraft.blaze_powder": "ﺐﻬﻠﻟﺍ ﺓﺭﺩﻮﺑ",
  "item.minecraft.magma_cream": "ﺓﺭﺎﻬﺼﻟﺍ ﻢﻳﺮﻛ",
  "block.minecraft.brewing_stand": "ﺮﻴﻤﺨﺘﻟﺍ ﺓﺪﻀﻨﻣ",
  "block.minecraft.cauldron": "ﺭﺪﻗ",
  "item.minecraft.ender_eye": "ﺭﺪﻧﻻﺍ ﻦﻴﻋ",
  "item.minecraft.glistering_melon_slice": "ﺔﻌﻣﻻ ﺦﻴﻄﺑ ﺔﻌﻄﻗ",
  "item.minecraft.bat_spawn_egg": "ﺵﺎﻔﺨﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.bee_spawn_egg": "ﺔﻠﺤﻧ ﺔﻀﻴﺑ",
  "item.minecraft.blaze_spawn_egg": "ﺐﻬﺘﻠﻤﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.cat_spawn_egg": "ﺔﻄﻘﻟﺍ ﺪﻴﻟﻮﺗ ﺔﻀﻴﺑ",
  "item.minecraft.cave_spider_spawn_egg": "ﻒﻬﻜﻟﺍ ﺕﻮﺒﻜﻨﻋ ﺔﻀﻴﺑ",
  "item.minecraft.chicken_spawn_egg": "ﺔﺟﺎﺟﺪﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.cod_spawn_egg": "ﺪﻘﻟﺍ ﺔﻜﻤﺳ ﺔﻀﻴﺑ",
  "item.minecraft.cow_spawn_egg": "ﺓﺮﻘﺒﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.creeper_spawn_egg": "ﺮﺠﻔﺘﻤﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.dolphin_spawn_egg": "ﻦﻴﻔﻟﺪﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.donkey_spawn_egg": "ﺭﺎﻤﺤﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.drowned_spawn_egg": "ﻕﺭﺎﻐﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.elder_guardian_spawn_egg": "ﻡﺪﻗﻷﺍ ﺱﺭﺎﺤﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.enderman_spawn_egg": "ﻥﺎﻣﺭﺪﻧﻷﺍ ﺔﻀﻴﺑ",
  "item.minecraft.endermite_spawn_egg": "ﺖﻳﺎﻣﺭﺪﻧﻷﺍ ﺔﻀﻴﺑ",
  "item.minecraft.evoker_spawn_egg": "ﺮﺣﺎﺴﻟﺍ ﻲﻋﺪﻤﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.fox_spawn_egg": "ﺐﻠﻌﺜﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.ghast_spawn_egg": "ﺢﺒﺸﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.guardian_spawn_egg": "ﺱﺭﺎﺤﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.hoglin_spawn_egg": "ﻦﻴﻠﺟﻮﻬﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.horse_spawn_egg": "ﻥﺎﺼﺤﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.husk_spawn_egg": "ﺮﺸﻘﺘﻤﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.llama_spawn_egg": "ﺎﻣﻼﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.magma_cube_spawn_egg": "ﺓﺭﺎﻬﺼﻟﺍ ﺐﻌﻜﻣ ﺔﻀﻴﺑ",
  "item.minecraft.mooshroom_spawn_egg": "ﺮﻄﻔﻟﺍ ﺓﺮﻘﺑ ﺔﻀﻴﺑ",
  "item.minecraft.mule_spawn_egg": "ﻞﻐﺒﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.ocelot_spawn_egg": "ﺕﻮﻠﺻﻷﺍ ﺔﻀﻴﺑ",
  "item.minecraft.panda_spawn_egg": "ﺍﺪﻧﺎﺒﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.parrot_spawn_egg": "ءﺎﻐﺒﺒﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.phantom_spawn_egg": "ﻒﻴﻄﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.pig_spawn_egg": "ﺮﻳﺰﻨﺨﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.piglin_spawn_egg": "ﻦﻠﺠﻴﺒﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.pillager_spawn_egg": "ﺐﻫﺎﻨﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.polar_bear_spawn_egg": "ﻲﺒﻄﻘﻟﺍ ﺏﺪﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.pufferfish_spawn_egg": "ﺔﺨﻔﺘﻨﻤﻟﺍ ﺔﻜﻤﺴﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.rabbit_spawn_egg": "ﺐﻧﺭﻷﺍ ﺔﻀﻴﺑ",
  "item.minecraft.ravager_spawn_egg": "ﺮﺠﻓﺍﺮﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.salmon_spawn_egg": "ﻥﻮﻤﻠﺴﻟﺍ ﺔﻜﻤﺳ ﺔﻀﻴﺑ",
  "item.minecraft.sheep_spawn_egg": "ﻑﻭﺮﺨﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.shulker_spawn_egg": "ﺮﻜﻟﺎﺸﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.silverfish_spawn_egg": "ﺔﻴﻀﻔﻟﺍ ﺔﻜﻤﺴﻟﺍ ﺓﺮﺸﺣ ﺔﻀﻴﺑ",
  "item.minecraft.skeleton_spawn_egg": "ﻲﻤﻈﻌﻟﺍ ﻞﻜﻴﻬﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.skeleton_horse_spawn_egg": "ﻲﻤﻈﻌﻟﺍ ﻞﻴﺨﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.slime_spawn_egg": "ﺝﺯﻼﻟﺍ ﺶﺣﻮﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.spider_spawn_egg": "ﺕﻮﺒﻜﻨﻌﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.squid_spawn_egg": "ﻁﻮﺒﻄﺧﻷﺍ ﺔﻀﻴﺑ",
  "item.minecraft.stray_spawn_egg": "ﻝﺎﻀﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.strider_spawn_egg": "ﺭﺪﻳﺍﺮﺘﺳ ﺔﻀﻴﺑ",
  "item.minecraft.trader_llama_spawn_egg": "ﺮﺟﺎﺘﻟﺍ ﺎﻣﻻ ﺔﻀﻴﺑ",
  "item.minecraft.tropical_fish_spawn_egg": "ﺔﻴﺋﺍﻮﺘﺳﻹﺍ ﺔﻜﻤﺴﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.turtle_spawn_egg": "ﺓﺎﻔﺤﻠﺴﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.vex_spawn_egg": "ﻆﻴﻐﻤﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.villager_spawn_egg": "ﻱﻭﺮﻘﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.vindicator_spawn_egg": "ﺐﺳﺎﺤﻤﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.wandering_trader_spawn_egg": "ﻝﻮﺠﺘﻤﻟﺍ ﻊﺋﺎﺒﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.witch_spawn_egg": "ﺓﺮﺣﺎﺴﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.wither_skeleton_spawn_egg": "ﻲﻤﻈﻌﻟﺍ ﺭﺫﻮﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.wolf_spawn_egg": "ﺐﺋﺬﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.zoglin_spawn_egg": "ﻦﻴﻠﺟﻭﺰﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.zombie_spawn_egg": "ﻲﺒﻣﻭﺰﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.zombie_horse_spawn_egg": "ﻲﺒﻣﻭﺰﻟﺍ ﻞﻴﺨﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.zombie_villager_spawn_egg": "ﻱﻭﺮﻘﻟﺍ ﻲﺒﻣﻭﺰﻟﺍ ﺔﻀﻴﺑ",
  "item.minecraft.zombified_piglin_spawn_egg": "ﻲﺒﻣﻭﺯ ﻦﻠﺠﻴﺑ ﺔﻀﻴﺑ",
  "item.minecraft.experience_bottle": "ﺮﺤﺴﻟﺍ ﺔﻨﻴﻨﻗ",
  "item.minecraft.fire_charge": "ﺔﻳﺭﺎﻧ ﺔﻨﺤﺷ",
  "item.minecraft.writable_book": "ﺔﺸﻳﺭ ﻭ ﺏﺎﺘﻛ",
  "item.minecraft.written_book": "ﺏﻮﺘﻜﻣ ﺏﺎﺘﻛ",
  "item.minecraft.emerald": "ﺩﺮﻣﺯ",
  "item.minecraft.item_frame": "ﺽﺍﺮﻏﻷﺍ ﺭﺎﻃﺇ",
  "block.minecraft.flower_pot": "ﺭﻮﻫﺰﻟﺍ ءﺎﻋﻭ",
  "item.minecraft.carrot": "ﺓﺭﺰﺟ",
  "item.minecraft.potato": "ﺲﻃﺎﻄﺑ",
  "item.minecraft.baked_potato": "ﺔﺧﻮﺒﻄﻣ ﺲﻃﺎﻄﺑ",
  "item.minecraft.poisonous_potato": "ﺔﻣﺎﺳ ﺎﻃﺎﻄﺑ",
  "item.minecraft.map": "ﺔﻏﺭﺎﻓ ﺔﻄﻳﺮﺧ",
  "item.minecraft.golden_carrot": "ﺔﻴﺒﻫﺫ ﺓﺭﺰﺟ",
  "block.minecraft.skeleton_skull": "ﻲﻤﻈﻋ ﻞﻜﻴﻫ ﺔﻤﺠﻤﺟ",
  "block.minecraft.wither_skeleton_skull": "ﻥﻮﺘﻠﻜﺳ ﺭﺬﻳﻭ ﺔﻤﺠﻤﺟ",
  "block.minecraft.player_head": "ﺐﻋﻼﻟﺍ ﺱﺃﺭ",
  "block.minecraft.zombie_head": "ﻲﺒﻣﻭﺯ ﺱﺃﺭ",
  "block.minecraft.creeper_head": "ﺮﺒﻳﺮﻛ ﺱﺃﺭ",
  "block.minecraft.dragon_head": "ﻦﻴﻨﺘﻟﺍ ﺱﺃﺭ",
  "item.minecraft.carrot_on_a_stick": "ﺎﺼﻋ ﻰﻠﻋ ﺓﺭﺰﺟ",
  "item.minecraft.warped_fungus_on_a_stick": "ﺎﺼﻋ ﻰﻠﻋ ﺐﻴﺠﻋ ﺮﻄﻓ",
  "item.minecraft.nether_star": "ﺭﺬﻨﻟﺍ ﺔﻤﺠﻧ",
  "item.minecraft.pumpkin_pie": "ﻦﻴﻄﻘﻳ ﺓﺮﻴﻄﻓ",
  "item.minecraft.firework_rocket": "ﺔﻳﺭﺎﻨﻟﺍ ﺏﺎﻌﻟﻷﺍ ﺥﻭﺭﺎﺻ",
  "item.minecraft.firework_star": "ﺔﻳﺭﺎﻨﻟﺍ ﺏﺎﻌﻟﻷﺍ ﺔﻤﺠﻧ",
  "item.minecraft.enchanted_book": "ﺭﻮﺤﺴﻣ ﺏﺎﺘﻛ",
  "item.minecraft.nether_brick": "ﺭﺬﻨﻟﺍ ﺏﻮﻃ",
  "item.minecraft.quartz": "ﺭﺬﻨﻟﺍ ﺰﺗﺭﺍﻮﻛ",
  "item.minecraft.tnt_minecart": "ﺖﻴﻣﺎﻨﻳﺩ ﻊﻣ ﻢﺠﻨﻣ ﺔﺑﺮﻋ",
  "item.minecraft.hopper_minecart": "ﺮﺑﻮﻫ ﻊﻣ ﻢﺠﻨﻣ ﺔﺑﺮﻋ",
  "item.minecraft.prismarine_shard": "ﻦﻳﺭﺎﻤﺳﺮﺑ ﺓﺮﺸﻗ",
  "item.minecraft.prismarine_crystals": "ﻦﻳﺭﺎﻤﺳﺮﺒﻟﺍ ﺕﺍﺭﻮﻠﺑ",
  "item.minecraft.rabbit": "ءﻲﻧ ﺐﻧﺭﺃ",
  "item.minecraft.cooked_rabbit": "ﺥﻮﺒﻄﻣ ﺐﻧﺭﺃ ﻢﺤﻟ",
  "item.minecraft.rabbit_stew": "ﺐﻧﺭﻷﺍ ءﺎﺴﺣ",
  "item.minecraft.rabbit_foot": "ﺐﻧﺭﺃ ﻞﺟﺭ",
  "item.minecraft.rabbit_hide": "ﺐﻧﺭﺃ ﺪﻠﺟ",
  "item.minecraft.armor_stand": "ﻉﺭﺪﻟﺍ ﻞﻣﺎﺣ",
  "item.minecraft.iron_horse_armor": "ﻱﺪﻳﺪﺣ ﻥﺎﺼﺣ ﻉﺭﺩ",
  "item.minecraft.golden_horse_armor": "ﻲﺒﻫﺫ ﻥﺎﺼﺣ ﻉﺭﺩ",
  "item.minecraft.diamond_horse_armor": "ﻲﺳﺎﻤﻟﺃ ﻥﺎﺼﺣ ﻉﺭﺩ",
  "item.minecraft.leather_horse_armor": "ﻱﺪﻠﺟ ﻥﺎﺼﺣ ﻉﺭﺩ",
  "item.minecraft.lead": "ﻞﺒﺣ",
  "item.minecraft.name_tag": "ﻢﺳﺍ ﺔﻣﻼﻋ",
  "item.minecraft.command_block_minecart": "ﺮﻣﺍﻭﻷﺍ ﺔﻠﺘﻛ ﻊﻣ ﻢﺠﻨﻣ ﺔﺑﺮﻋ",
  "item.minecraft.mutton": "ءﻲﻧ ﻥﺄﺿ ﻢﺤﻟ",
  "item.minecraft.cooked_mutton": "ﺥﻮﺒﻄﻣ ﻥﺄﺿ ﻢﺤﻟ",
  "block.minecraft.white_banner": "ءﺎﻀﻴﺑ ﺔﻳﺍﺭ",
  "block.minecraft.orange_banner": "ﺔﻴﻟﺎﻘﺗﺮﺑ ﺔﻳﺍﺭ",
  "block.minecraft.magenta_banner": "ﺔﻴﻧﺍﻮﺟﺭﺃ ﺔﻳﺍﺭ",
  "block.minecraft.light_blue_banner": "ﺔﺤﺗﺎﻓ ءﺎﻗﺭﺯ ﺔﻳﺍﺭ",
  "block.minecraft.yellow_banner": "ءﺍﺮﻔﺻ ﺔﻳﺍﺭ",
  "block.minecraft.lime_banner": "ﺔﻴﻧﻮﻤﻴﻟ ﺔﻳﺍﺭ",
  "block.minecraft.pink_banner": "ﺔﻳﺩﺭﻭ ﺔﻳﺍﺭ",
  "block.minecraft.gray_banner": "ﺔﻳﺩﺎﻣﺭ ﺔﻳﺍﺭ",
  "block.minecraft.light_gray_banner": "ﺔﺤﺗﺎﻓ ﺔﻳﺩﺎﻣﺭ ﺔﻳﺍﺭ",
  "block.minecraft.cyan_banner": "ﺔﻳﻭﺎﻤﺳ ﺔﻳﺍﺭ",
  "block.minecraft.purple_banner": "ﺔﻴﺠﺴﻔﻨﺑ ﺔﻳﺍﺭ",
  "block.minecraft.blue_banner": "ءﺎﻗﺭﺯ ﺔﻳﺍﺭ",
  "block.minecraft.brown_banner": "ﺔﻴﻨﺑ ﺔﻳﺍﺭ",
  "block.minecraft.green_banner": "ءﺍﺮﻀﺧ ﺔﻳﺍﺭ",
  "block.minecraft.red_banner": "ءﺍﺮﻤﺣ ﺔﻳﺍﺭ",
  "block.minecraft.black_banner": "ءﺍﺩﻮﺳ ﺔﻳﺍﺭ",
  "item.minecraft.end_crystal": "ﺪﻧﻻﺍ ﺔﻟﺎﺘﺴﻳﺮﻛ",
  "item.minecraft.chorus_fruit": "ﺱﺭﻮﻜﻟﺍ ﺔﻬﻛﺎﻓ",
  "item.minecraft.popped_chorus_fruit": "ﺔﻌﻗﺮﻔﻤﻟﺍ ﺱﺭﻮﻜﻟﺍ ﺔﻬﻛﺎﻓ",
  "item.minecraft.beetroot": "ﺭﺪﻨﻤﺷ",
  "item.minecraft.beetroot_seeds": "ﺭﺪﻨﻤﺸﻟﺍ ﺭﻭﺬﺑ",
  "item.minecraft.beetroot_soup": "ﺭﺪﻨﻤﺸﻟﺍ ءﺎﺴﺣ",
  "item.minecraft.dragon_breath": "ﻦﻴﻨﺘﻟﺍ ﺲﻔﻧ",
  "item.minecraft.splash_potion": "ﻊﻨﺼﻠﻟ ﺔﻠﺑﺎﻗ ﺮﻴﻐﻟﺍ ﺔﻋﺮﺠﻟﺍ ﺔﺷﺭ□ﺕﺍﺮﻴﺛﺄﺗ ﻻ",
  "item.minecraft.spectral_arrow": "ﻲﻔﻴﻃ ﻢﻬﺳ",
  "item.minecraft.tipped_arrow": "ﻪﻌﻨﺻ ﻦﻜﻤﻳ ﻻ ﻲﻠﻄﻣ ﻢﻬﺳ□ﺕﺍﺮﻴﺛﺄﺗ ﻻ",
  "item.minecraft.lingering_potion": "ﻊﻨﺼﻠﻟ ﺔﻠﺑﺎﻗ ﺮﻴﻐﻟﺍ ﺔﻋﺮﺠﻟﺍ ﺯﺎﻏ□ﺕﺍﺮﻴﺛﺄﺗ ﻻ",
  "item.minecraft.shield": "ﻉﺭﺩ",
  "item.minecraft.elytra": "ﺍﺮﺘﻴﻟﺇ",
  "item.minecraft.spruce_boat": "ﺏﻮﻨﺘﻟﺍ ﺏﺭﺎﻗ",
  "item.minecraft.birch_boat": "ﻻﻮﺘﺒﻟﺍ ﺏﺭﺎﻗ",
  "item.minecraft.jungle_boat": "ﻝﺎﻏﺩﻷﺍ ﺏﺭﺎﻗ",
  "item.minecraft.acacia_boat": "ﻂﻨﺴﻟﺍ ﺏﺭﺎﻗ",
  "item.minecraft.dark_oak_boat": "ﻦﻛﺍﺪﻟﺍ ﻁﻮﻠﺒﻟﺍ ﺏﺭﺎﻗ",
  "item.minecraft.totem_of_undying": "ﺩﻮﻠﺨﻟﺍ ﺔﻤﻴﻤﺗ",
  "item.minecraft.shulker_shell": "ﺮﻜﻠﺸﻟﺍ ﺔﻓﺪﺻ",
  "item.minecraft.iron_nugget": "ﺔﻳﺪﻳﺪﺣ ﺔﻌﻄﻗ",
  "item.minecraft.knowledge_book": "ﺔﻓﺮﻌﻤﻟﺍ ﺏﺎﺘﻛ",
  "item.minecraft.debug_stick": "ﺢﻴﺤﺼﺘﻟﺍ ﺎﺼﻋ",
  "item.minecraft.music_disc_13": "ﻲﻧﺎﻏﺃ ﺔﻧﺍﻮﻄﺳﺃ□c418 - 13",
  "item.minecraft.music_disc_cat": "ﻲﻧﺎﻏﺃ ﺔﻧﺍﻮﻄﺳﺃ□c418 - cat",
  "item.minecraft.music_disc_blocks": "ﻲﻧﺎﻏﺃ ﺔﻧﺍﻮﻄﺳﺃ□c418 - blocks",
  "item.minecraft.music_disc_chirp": "ﻲﻧﺎﻏﺃ ﺔﻧﺍﻮﻄﺳﺃ□c418 - chirp",
  "item.minecraft.music_disc_far": "ﻲﻧﺎﻏﺃ ﺔﻧﺍﻮﻄﺳﺃ□c418 - far",
  "item.minecraft.music_disc_mall": "ﻲﻧﺎﻏﺃ ﺔﻧﺍﻮﻄﺳﺃ□c418 - mall",
  "item.minecraft.music_disc_mellohi": "ﻲﻧﺎﻏﺃ ﺔﻧﺍﻮﻄﺳﺃ□c418 - mellohi",
  "item.minecraft.music_disc_stal": "ﻲﻧﺎﻏﺃ ﺔﻧﺍﻮﻄﺳﺃ□c418 - stal",
  "item.minecraft.music_disc_strad": "ﻲﻧﺎﻏﺃ ﺔﻧﺍﻮﻄﺳﺃ□c418 - strad",
  "item.minecraft.music_disc_ward": "ﻲﻧﺎﻏﺃ ﺔﻧﺍﻮﻄﺳﺃ□c418 - ward",
  "item.minecraft.music_disc_11": "ﻲﻧﺎﻏﺃ ﺔﻧﺍﻮﻄﺳﺃ□c418 - 11",
  "item.minecraft.music_disc_wait": "ﻲﻧﺎﻏﺃ ﺔﻧﺍﻮﻄﺳﺃ□c418 - wait",
  "item.minecraft.music_disc_pigstep": "ﻲﻧﺎﻏﺃ ﺔﻧﺍﻮﻄﺳﺃ□pigstep - ﻦﻳﹶﺭ ﺎﻨﻴﹷﻟ",
  "item.minecraft.trident": "ﺢﻣﺮﻟﺍ□□:ﺔﻴﺴﻴﺋﺮﻟﺍ ﺪﻴﻟﺍ ﻲﻓ ﻥﻮﻜﻳ ﺎﻣﺪﻨﻋ□ﻡﻮﺠﻬﻟﺍ ﺭﺮﺿ 8+□ﻡﻮﺠﻬﻟﺍ ﺔﻋﺮﺳ 2.9-",
  "item.minecraft.phantom_membrane": "ﻒﻴﻄﻟﺍ ءﺎﺸﻏ",
  "item.minecraft.nautilus_shell": "ﻲﺗﻮﻨﻟﺍ ﺔﻓﺪﺻ",
  "item.minecraft.heart_of_the_sea": "ﺮﺤﺒﻟﺍ ﺐﻠﻗ",
  "item.minecraft.crossbow": "ﺏﺎﺸﻨﻟﺍﻭ ﺱﻮﻘﻟﺍ",
  "item.minecraft.suspicious_stew": "ﺐﻳﺮﻣ ءﺎﺴﺣ",
  "block.minecraft.loom": "ﺞﺴﻨﻣ",
  "item.minecraft.flower_banner_pattern": "ﺔﻳﺍﺮﻟﺍ ﻂﻤﻧ□ﺓﺮﻫﺯ ﺭﺎﻌﺷ",
  "item.minecraft.creeper_banner_pattern": "ﺔﻳﺍﺮﻟﺍ ﻂﻤﻧ□ﺮﺒﻳﺮﻛ ﺭﺎﻌﺷ",
  "item.minecraft.skull_banner_pattern": "ﺔﻳﺍﺮﻟﺍ ﻂﻤﻧ□ﺔﻤﺠﻤﺟ ﺭﺎﻌﺷ",
  "item.minecraft.mojang_banner_pattern": "ﺔﻳﺍﺮﻟﺍ ﻂﻤﻧ□ءﻲﺷ",
  "item.minecraft.globe_banner_pattern": "ﺔﻳﺍﺮﻟﺍ ﻂﻤﻧ□ﺔﻴﺿﺭﻷﺍ ﺓﺮﻜﻟﺍ",
  "item.minecraft.piglin_banner_pattern": "ﺔﻳﺍﺮﻟﺍ ﻂﻤﻧ□ﻒﻧﺃ",
  "block.minecraft.composter": "ﺪﹻﹽﻤﺴﻣ",
  "block.minecraft.barrel": "ﻞﻴﻣﺮﺑ",
  "block.minecraft.smoker": "ﻦﺧﺪﻣ",
  "block.minecraft.blast_furnace": "ﻥﺩﺎﻌﻤﻟﺍ ﺮﻬﺻ ﻥﺮﻓ",
  "block.minecraft.cartography_table": "ﻂﺋﺍﺮﺨﻟﺍ ﻢﺳﺭ ﺔﻟﻭﺎﻃ",
  "block.minecraft.fletching_table": "ﻢﻬﺳﻷﺍ ﺔﻋﺎﻨﺻ ﺔﻟﻭﺎﻃ",
  "block.minecraft.grindstone": "ﺬﺤﺸﻟﺍ ﺮﺠﺣ",
  "block.minecraft.lectern": "ﺓءﺍﺮﻘﻟﺍ ﺔﺼﻨﻣ",
  "block.minecraft.smithing_table": "ﺓﺩﺍﺪﺤﻟﺍ ﺓﺪﻀﻨﻣ",
  "block.minecraft.stonecutter": "ﺓﺭﺎﺠﺤﻟﺍ ﻊﻃﺎﻗ",
  "block.minecraft.bell": "ﺱﺮﺟ",
  "block.minecraft.lantern": "ﺱﻮﻧﺎﻓ",
  "block.minecraft.soul_lantern": "ﺡﻭﺮﻟﺍ ﺱﻮﻧﺎﻓ",
  "item.minecraft.sweet_berries": "ﻮﻠﺤﻟﺍ ﺕﻮﺘﻟﺍ",
  "block.minecraft.campfire": "ﺪﻗﻮﻣ",
  "block.minecraft.soul_campfire": "ﺡﻭﺮﻟﺍ ﺭﺎﻧ ﺪﻗﻮﻣ",
  "block.minecraft.shroomlight": "ﺮﻄﻔﻟﺍ ءﻮﺿ",
  "item.minecraft.honeycomb": "ﻞﺴﻋ ﺹﺮﻗ",
  "block.minecraft.bee_nest": "ﻞﺤﻧ ﺶﻋ",
  "block.minecraft.beehive": "ﻞﺤﻧ ﺔﻴﻠﺧ",
  "item.minecraft.honey_bottle": "ﻞﺴﻋ ﺔﺟﺎﺟﺯ",
  "block.minecraft.honey_block": "ﻞﺴﻋ ﺔﻠﺘﻛ",
  "block.minecraft.honeycomb_block": "ﻞﺴﻌﻟﺍ ﺹﺍﺮﻗﺃ ﻪﻠﺘﻛ",
  "block.minecraft.lodestone": "ﺲﻴﻃﺎﻨﻐﻤﻟﺍ ﺮﺠﺣ",
  "block.minecraft.netherite_block": "ﺖﻳﺍﺭﺬﻨﻟﺍ ﻦﻣ ﺔﻠﺘﻛ",
  "block.minecraft.ancient_debris": "ﻢﻳﺪﻗ ﻡﺎﻄﺣ",
  "block.minecraft.target": "ﻑﺪﻫ",
  "block.minecraft.crying_obsidian": "ﻲﻛﺎﺒﻟﺍ ﺞﺒﺴﻟﺍ",
  "block.minecraft.blackstone": "ﺩﻮﺳﺃ ﺮﺠﺣ",
  "block.minecraft.blackstone_slab": "ﺩﻮﺳﺃ ﺮﺠﺣ ﺔﻃﻼﺑ",
  "block.minecraft.blackstone_stairs": "ﺩﻮﺳﺃ ﺮﺠﺣ ﺝﺭﺩ",
  "block.minecraft.gilded_blackstone": "ﺐﹷﹽﻫﹶﺬﹹﻣ ﺩﻮﺳﺃ ﺮﺠﺣ",
  "block.minecraft.polished_blackstone": "ﻝﻮﻘﺼﻣ ﺩﻮﺳﺃ ﺮﺠﺣ",
  "block.minecraft.polished_blackstone_slab": "ﻝﻮﻘﺼﻣ ﺩﻮﺳﺃ ﺮﺠﺣ ﺔﻃﻼﺑ",
  "block.minecraft.polished_blackstone_stairs": "ﻝﻮﻘﺼﻣ ﺩﻮﺳﺃ ﺮﺠﺣ ﺝﺭﺩ",
  "block.minecraft.chiseled_polished_blackstone": "ﺵﻮﻘﻨﻣ ﻝﻮﻘﺼﻣ ﺩﻮﺳﺃ ﺮﺠﺣ",
  "block.minecraft.polished_blackstone_bricks": "ﻝﻮﻘﺼﻣ ﺩﻮﺳﺃ ﺮﺠﺣ ﺏﻮﻃ",
  "block.minecraft.polished_blackstone_brick_slab": "ﻝﻮﻘﺼﻣ ﺩﻮﺳﺃ ﺮﺠﺣ ﺏﻮﻃ ﺔﻃﻼﺑ",
  "block.minecraft.polished_blackstone_brick_stairs": "ﻝﻮﻘﺼﻣ ﺩﻮﺳﺃ ﺮﺠﺣ ﺏﻮﻃ ﺭﺍﺪﺟ",
  "block.minecraft.cracked_polished_blackstone_bricks": "ﻖﻘﺸﺘﻣ ﻝﻮﻘﺼﻣ ﺩﻮﺳﺃ ﺮﺠﺣ ﺏﻮﻃ",
  "block.minecraft.respawn_anchor": "ءﺎﻴﺣﻹﺍ ﺓﺩﺎﻋﺇ ﺓﺎﺳﺮﻣ",
}
export const ar_sa = items; 
